// import { useState, useEffect, useMemo, useCallback, useRef } from "react";
// import { Filter, X, ChevronDown, ChevronUp, Loader } from "lucide-react";
// import { FaShoppingBag } from "react-icons/fa";
// import "./ProductsCollectionList.scss";
// import ProductsApiService from "../../services/ProductsApiService";
// import { Link, useLocation, useParams } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import { useCart } from "../../context/CartContext";
// import { getLanguage } from "../../utils/Helper";
// import { toast } from "react-toastify";
// import WishlistButton from "../../components/general/wishlistButton/WishlistButton";

// const ProductsCollectionList = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [, setError] = useState(null);
//   const [colorsAndSizes, setColorsAndSizes] = useState(null);
//   const lang = getLanguage();

//   const { collectionName, categoryName } = useParams();
//   const location = useLocation();
//   const authContext = useAuth();
//   const { addToCart } = useCart();

//   const [cartStates, setCartStates] = useState({});
//   const addToCartTimeoutRefs = useRef({});
  
//   // ✅ Infinite Scroll Refs
//   const observerTarget = useRef(null);
//   const isFirstLoad = useRef(true);
//   const isFetchingRef = useRef(false);
//   const queryParams = new URLSearchParams(location.search);
//   const subCategoriesParams = queryParams.get("sub_cat")
//     ? queryParams.get("sub_cat").split(",")
//     : [];
//   const brandsParams = queryParams.get("brand")
//     ? queryParams.get("brand").split(",")
//     : [];

//   const [currentCollection, setCurrentCollection] = useState(null);
//   const [, setActiveCategory] = useState(null);

//   const [pagination, setPagination] = useState({
//     currentPage: 0,
//     pageSize: 10,
//     totalCount: 0,
//     totalPages: 0,
//   });

//   const [filters, setFilters] = useState({
//     collectionId: currentCollection?.id,
//     categoryIds: [],
//     subCategoryIds: [],
//     brandIds: [],
//     colorIds: [],
//     sizeIds: [],
//     minPrice: null,
//     maxPrice: null,
//     search: "",
//     isNew: null,
//     isTrend: null,
//     isTopSeller: null,
//     sortBy: "newest",
//   });

//   const [showFilters, setShowFilters] = useState(true);
//   const [expandedSections, setExpandedSections] = useState({
//     category: true,
//     subCategory: false,
//     brand: false,
//     color: false,
//     size: false,
//     status: true,
//   });

//   const filterOptions = useMemo(() => {
//     if (!currentCollection || !colorsAndSizes)
//       return {
//         categories: [],
//         subCategories: [],
//         brands: [],
//         colors: [],
//         sizes: [],
//       };

//     const categories = new Map();
//     const subCategories = new Map();
//     const brands = new Map();
//     const colors = new Map();
//     const sizes = new Map();

//     currentCollection?.categories.forEach((cat) => {
//       if (cat) categories.set(cat?.id, { ...cat, nameEn: cat.name_url });
//       cat?.sub_categories.forEach((sub) => {
//         if (sub)
//           subCategories.set(sub?.id, {
//             ...sub,
//             nameEn: sub.name_url,
//             categoryId: cat.id,
//           });
//       });
//     });

//     currentCollection?.top_brands.forEach((brand) => {
//       if (brand) {
//         brands.set(brand?.id, { ...brand, nameEn: brand.name_url });
//       }
//     });

//     colorsAndSizes?.colors.forEach((color) => {
//       if (color) colors.set(color.id, color);
//     });

//     colorsAndSizes?.sizes.forEach((size) => {
//       if (size) sizes.set(size.id, size);
//     });

//     let filteredSubCategories = Array.from(subCategories.values());
//     if (filters.categoryIds.length > 0) {
//       filteredSubCategories = filteredSubCategories.filter((sub) =>
//         filters.categoryIds.includes(sub.categoryId),
//       );
//     }

//     return {
//       categories: Array.from(categories.values()),
//       subCategories: filteredSubCategories,
//       brands: Array.from(brands.values()),
//       colors: Array.from(colors.values()),
//       sizes: Array.from(sizes.values()),
//     };
//   }, [currentCollection, colorsAndSizes, filters.categoryIds]);

//   const fetchProducts = async (isLoadMore = false) => {
//     if (!currentCollection || !colorsAndSizes) return;

//     try {
//       if (isLoadMore) {
//         setLoadingMore(true);
//       } else {
//         setLoading(true);
//       }
//       setError(null);
//       const queryParams = new URLSearchParams();
//       queryParams.append("page", pagination.currentPage);
//       queryParams.append("limit", pagination.pageSize);

//       queryParams.append("collectionId", currentCollection?.id);
//       if (filters.categoryIds.length)
//         filters.categoryIds.forEach((id) =>
//           queryParams.append("categoryIds", id),
//         );
//       if (filters.subCategoryIds.length)
//         filters.subCategoryIds.forEach((id) =>
//           queryParams.append("subCategoryIds", id),
//         );
//       if (filters.brandIds.length)
//         filters.brandIds.forEach((id) => queryParams.append("brandIds", id));
//       if (filters.colorIds.length)
//         filters.colorIds.forEach((id) => queryParams.append("colorIds", id));
//       if (filters.sizeIds.length)
//         filters.sizeIds.forEach((id) => queryParams.append("sizeIds", id));
//       if (filters.minPrice) queryParams.append("minPrice", filters.minPrice);
//       if (filters.maxPrice) queryParams.append("maxPrice", filters.maxPrice);
//       if (filters.search) queryParams.append("search", filters.search);
//       if (filters.isNew !== null) queryParams.append("isNew", filters.isNew);
//       if (filters.isTrend !== null)
//         queryParams.append("isTrend", filters.isTrend);
//       if (filters.isTopSeller !== null)
//         queryParams.append("isTopSeller", filters.isTopSeller);
//       queryParams.append("sortBy", filters.sortBy);

//       const response =
//         await ProductsApiService.getProductsListWithFilters(queryParams);

//       if (isLoadMore) {
//         // ✅ إضافة deduplication باستخدام Set
//         setProducts((prev) => {
//           const existingIds = new Set(prev.map(p => p.id));
//           const newProducts = (response.products || []).filter(
//             product => !existingIds.has(product.id)
//           );
//           return [...prev, ...newProducts];
//         });
//       } else {
//         setProducts(response.products || []);
//       }

//       setPagination({
//         currentPage: response.currentPage,
//         pageSize: response.pageSize,
//         totalCount: response.totalCount,
//         totalPages: response.totalPages,
//       });
//     } catch (err) {
//       setError(err.message);
//       setPagination({
//         currentPage: 0,
//         pageSize: 10,
//         totalCount: 0,
//         totalPages: 0,
//       });
//     } finally {
//       setLoading(false);
//       setLoadingMore(false);
//     }
//   };

//   // ✅ تحديث Load More Handler
//   const handleLoadMore = useCallback(() => {
//     if (loadingMore || loading || isFetchingRef.current) return;
//     if (pagination.currentPage >= pagination.totalPages - 1) return;
    
//     isFetchingRef.current = true;
//     setPagination((prev) => ({ ...prev, currentPage: prev.currentPage + 1 }));
//   }, [loadingMore, loading, pagination.currentPage, pagination.totalPages]);

//   // ✅ Intersection Observer Setup
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         const target = entries[0];
        
//         if (
//           target.isIntersecting && 
//           !loadingMore && 
//           !loading && 
//           !isFetchingRef.current &&
//           pagination.currentPage < pagination.totalPages - 1
//         ) {
//           handleLoadMore();
//         }
//       },
//       {
//         root: null,
//         rootMargin: "200px",
//         threshold: 0.1,
//       }
//     );

//     const currentTarget = observerTarget.current;
//     if (currentTarget) {
//       observer.observe(currentTarget);
//     }

//     return () => {
//       if (currentTarget) {
//         observer.unobserve(currentTarget);
//       }
//     };
//   }, [handleLoadMore, loadingMore, loading, pagination.currentPage, pagination.totalPages]);

//   function loadCollectionsData() {
//     if (!authContext?.systemCollections?.length) return;

//     const collection = authContext.systemCollections.find(
//       (col) =>
//         col.name_url.toLowerCase().trim() ===
//         collectionName.split("-").join(" ").toLowerCase().trim(),
//     );
//     if (!collection) return;

//     setCurrentCollection(collection);

//     if (categoryName) {
//       const category = collection.categories.find(
//         (cat) =>
//           cat.name_url.toLowerCase().trim() ===
//           categoryName.split("-").join(" ").toLowerCase().trim(),
//       );
//       setActiveCategory(category);

//       const selectedSubIds =
//         category?.sub_categories
//           .filter((subCat) =>
//             subCategoriesParams.some(
//               (name) =>
//                 subCat.name_url.toLowerCase().trim() ===
//                 name.split("-").join(" ").toLowerCase().trim(),
//             ),
//           )
//           .map((sub) => sub.id) || [];

//       setFilters((prev) => ({
//         ...prev,
//         collectionId: collection.id,
//         categoryIds: category ? [category.id] : [],
//         subCategoryIds: selectedSubIds,
//         brandIds:
//           collection?.top_brands
//             ?.filter((brand) =>
//               brandsParams.some(
//                 (name) =>
//                   brand.name_url.toLowerCase().trim() ===
//                   name.split("-").join(" ").toLowerCase().trim(),
//               ),
//             )
//             .map((br) => br.id) || [],
//       }));
//     } else {
//       setFilters((prev) => ({
//         ...prev,
//         categoryIds: [],
//         subCategoryIds: [],
//         collectionId: collection.id,
//         brandIds:
//           collection?.top_brands
//             ?.filter((brand) =>
//               brandsParams.some(
//                 (name) =>
//                   brand.name_url.toLowerCase().trim() ===
//                   name.split("-").join(" ").toLowerCase().trim(),
//               ),
//             )
//             .map((br) => br.id) || [],
//       }));
//     }
//   }

//   async function fetchColorsAndSizes() {
//     try {
//       if (colorsAndSizes?.colors && colorsAndSizes?.sizes) return;
//       const response = await ProductsApiService.getColorsAndSizesByFilters({
//         collectionId: currentCollection?.id,
//         categoryIds: filters.categoryIds?.join(","),
//         subCategoryIds: filters.subCategoryIds?.join(","),
//         brandIds: filters.brandIds?.join(","),
//       });
//       setColorsAndSizes(response);
//     } catch (err) {
//       console.error("Error fetching colors and sizes:", err);
//     }
//   }

//   const isProductOutOfStock = useCallback((product) => {
//     if (!product.variants || product.variants.length === 0) {
//       return true;
//     }

//     let outOfStock = true;
//     product.variants.forEach((v) => {
//       if ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0)) {
//         outOfStock = false;
//         return;
//       }
//     });

//     return outOfStock;
//   }, []);

//   const handleAddToCart = useCallback(
//     async (e, product) => {
//       e.preventDefault();
//       e.stopPropagation();

//       if (isProductOutOfStock(product)) {
//         toast.warning(
//           lang === "EN" ? "Product is out of stock" : "المنتج غير متوفر حالياً",
//         );
//         return;
//       }

//       const productId = product.id;

//       if (cartStates[productId]?.isAdding) return;

//       if (addToCartTimeoutRefs.current[productId]) {
//         clearTimeout(addToCartTimeoutRefs.current[productId]);
//       }

//       setCartStates((prev) => ({
//         ...prev,
//         [productId]: { isAdding: true, showSuccess: false },
//       }));

//       try {
//         if (product.variants && product.variants.length > 0) {
//           const apiVariant = product.variants.find(
//             (v) => (v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0),
//           ) || product.variants[0];

//           const variant = {
//             id: apiVariant.id,
//             productId: apiVariant.productId,
//             color: apiVariant.color,
//             size: apiVariant.size,
//             price:
//               typeof apiVariant.price === "object"
//                 ? apiVariant.price.parsedValue
//                 : apiVariant.price,
//             discountPrice:
//               apiVariant.discountPrice &&
//               typeof apiVariant.discountPrice === "object"
//                 ? apiVariant.discountPrice.parsedValue
//                 : apiVariant.discountPrice,
//             quantity: apiVariant.quantity,
//             reservedQuantity: apiVariant.reservedQuantity,
//             withoutBoxQuantity: apiVariant.withoutBoxQuantity,
//             withoutBoxReservedQuantity: apiVariant.withoutBoxReservedQuantity,
//             stockStatus: apiVariant.stockStatus || "In Stock",
//           };

//           const cartProduct = {
//             id: product.id,
//             nameEn: product.nameEn,
//             nameAr: product.nameAr,
//             descriptionEn: product.descriptionEn,
//             descriptionAr: product.descriptionAr,
//             images: [{ image_url: product.primaryImageUrl }],
//             brand: {
//               nameEn: product.brand?.nameEn,
//               nameAr: product.brand?.nameAr,
//             },
//             collection: { nameEn: product.collection?.nameEn },
//             category: { nameEn: product.category?.nameEn },
//             subCategory: { nameEn: product.subCategory?.nameEn },
//           };

//           await addToCart(cartProduct, variant, 1, ((apiVariant.quantity - apiVariant.reservedQuantity > 0)? false: true), false);

//           setCartStates((prev) => ({
//             ...prev,
//             [productId]: { isAdding: false, showSuccess: true },
//           }));

//           addToCartTimeoutRefs.current[productId] = setTimeout(() => {
//             setCartStates((prev) => ({
//               ...prev,
//               [productId]: { isAdding: false, showSuccess: false },
//             }));
//           }, 2000);
//         } else {
//           toast.error(
//             lang === "EN"
//               ? "This product has no available variants"
//               : "هذا المنتج ليس له مقاسات متاحة",
//           );
//           setCartStates((prev) => ({
//             ...prev,
//             [productId]: { isAdding: false, showSuccess: false },
//           }));
//         }
//       } catch (error) {
//         console.error("Error adding to cart:", error);
//         toast.error(
//           lang === "EN"
//             ? "Something went wrong while adding to cart"
//             : "حدث خطأ أثناء إضافة المنتج للسلة",
//         );
//         setCartStates((prev) => ({
//           ...prev,
//           [productId]: { isAdding: false, showSuccess: false },
//         }));
//       }
//     },
//     [addToCart, cartStates, lang, isProductOutOfStock],
//   );

//   // ✅ تحديث useEffect للـ fetchProducts
//   useEffect(() => {
//     if (
//       currentCollection &&
//       colorsAndSizes &&
//       pagination?.currentPage !== null
//     ) {
//       const isLoadMore = pagination.currentPage > 0;
//       fetchProducts(isLoadMore).finally(() => {
//         isFetchingRef.current = false;
//       });
      
//       if (isFirstLoad.current && !isLoadMore) {
//         isFirstLoad.current = false;
//       }
//     }
//   }, [pagination.currentPage, currentCollection, colorsAndSizes]);

//   useEffect(() => {
//     loadCollectionsData();
//   }, [authContext, collectionName, categoryName]);

//   useEffect(() => {
//     if (currentCollection) {
//       fetchColorsAndSizes();
//     }
//   }, [currentCollection, collectionName, categoryName]);

//   useEffect(() => {
//     const debounceTimer = setTimeout(() => {
//       isFirstLoad.current = true;
      
//       if (pagination.currentPage === 0) {
//         fetchProducts(false);
//       } else {
//         setPagination((prev) => ({ ...prev, currentPage: 0 }));
//         setProducts([]);
//       }
//     }, 1000);

//     return () => clearTimeout(debounceTimer);
//   }, [filters]);

//   const toggleFilter = (filterType, id) => {
//     setFilters((prev) => {
//       const newFilters = {
//         ...prev,
//         [filterType]: prev[filterType].includes(id)
//           ? prev[filterType].filter((item) => item !== id)
//           : [...prev[filterType], id],
//       };

//       if (filterType === "categoryIds" && prev[filterType].includes(id)) {
//         const subCatsToRemove = filterOptions.subCategories
//           .filter((sub) => sub.categoryId === id)
//           .map((sub) => sub.id);

//         newFilters.subCategoryIds = prev.subCategoryIds.filter(
//           (subId) => !subCatsToRemove.includes(subId),
//         );
//       }

//       return newFilters;
//     });
//   };

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
//   };

//   const toggleStatusFilter = (statusType) => {
//     setFilters((prev) => ({
//       ...prev,
//       [statusType]: prev[statusType] ? null : true,
//     }));
//   };

//   const clearAllFilters = () => {
//     setFilters({
//       categoryIds: [],
//       subCategoryIds: [],
//       brandIds: [],
//       colorIds: [],
//       sizeIds: [],
//       minPrice: null,
//       maxPrice: null,
//       search: "",
//       isNew: null,
//       isTrend: null,
//       isTopSeller: null,
//       sortBy: "newest",
//     });
//   };

//   const activeFiltersCount =
//     filters.categoryIds.length +
//     filters.subCategoryIds.length +
//     filters.brandIds.length +
//     filters.colorIds.length +
//     filters.sizeIds.length +
//     (filters.isNew ? 1 : 0) +
//     (filters.isTrend ? 1 : 0) +
//     (filters.isTopSeller ? 1 : 0);

//   const openProductProfile = (pro) => {
//     const collectionName = pro.collection.nameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     const catName = pro.category.nameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     const subCatName = pro.subCategory.nameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     return `/collection/${collectionName}/${catName}/${subCatName}/${pro.id}`;
//   };

//   const hasMoreProducts = pagination.currentPage < pagination.totalPages - 1;

//   return (
//     <div className="min-vh-100 pb-4 products-collection-page" style={{ paddingTop: "140px" }}>
//       <div className="container-fluid py-3 px-lg-5">
//         {/* Collection Hero Image */}
//         <div className="col-12 mb-4">
//           <img
//             src={currentCollection?.image_url}
//             alt=""
//             className="collection-image-section"
//           />
//         </div>

//         <div className="row g-4">
//           {/* Filters Sidebar */}
//           {showFilters && (
//             <div className="col-lg-3">
//               <div className="card shadow-sm filters-sidebar">
//                 <div className="card-body">
//                   {/* Filter Header */}
//                   <div className="filter-header">
//                     <div className="filter-title">
//                       <Filter size={20} />
//                       <span>{lang === "EN" ? "Filters" : "الفلاتر"}</span>
//                       {activeFiltersCount > 0 && (
//                         <span className="filter-count">
//                           {activeFiltersCount}
//                         </span>
//                       )}
//                     </div>
//                     {activeFiltersCount > 0 && (
//                       <button
//                         onClick={clearAllFilters}
//                         className="clear-filters-btn"
//                       >
//                         {lang === "EN" ? "Clear all" : "مسح الكل"}
//                       </button>
//                     )}
//                   </div>

//                   {/* Status Filter */}
//                   <div className="filter-section">
//                     <button
//                       onClick={() => toggleSection("status")}
//                       className={`filter-section-header ${expandedSections.status ? "expanded" : ""}`}
//                     >
//                       <h6 className="filter-section-title">
//                         {lang === "EN" ? "Status" : "حالة المنتج"}
//                       </h6>
//                       {expandedSections.status ? (
//                         <ChevronUp size={18} />
//                       ) : (
//                         <ChevronDown size={18} />
//                       )}
//                     </button>
//                     {expandedSections.status && (
//                       <div className="filter-collapse">
//                         <div className="form-check">
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             id="status-new"
//                             checked={filters.isNew === true}
//                             onChange={() => toggleStatusFilter("isNew")}
//                           />
//                           <label
//                             className="form-check-label"
//                             htmlFor="status-new"
//                           >
//                             {lang === "EN" ? "New Arrival" : "جديد"}
//                           </label>
//                         </div>
//                         <div className="form-check">
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             id="status-trend"
//                             checked={filters.isTrend === true}
//                             onChange={() => toggleStatusFilter("isTrend")}
//                           />
//                           <label
//                             className="form-check-label"
//                             htmlFor="status-trend"
//                           >
//                             {lang === "EN" ? "Trending" : "ترندات"}
//                           </label>
//                         </div>
//                         <div className="form-check">
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             id="status-topseller"
//                             checked={filters.isTopSeller === true}
//                             onChange={() => toggleStatusFilter("isTopSeller")}
//                           />
//                           <label
//                             className="form-check-label"
//                             htmlFor="status-topseller"
//                           >
//                             {lang === "EN" ? "Top Seller" : "أكثر مبيعا"}
//                           </label>
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                   {/* Category Filter */}
//                   {filterOptions.categories.length > 0 && (
//                     <div className="filter-section">
//                       <button
//                         onClick={() => toggleSection("category")}
//                         className={`filter-section-header ${expandedSections.category ? "expanded" : ""}`}
//                       >
//                         <h6 className="filter-section-title">
//                           {lang === "EN" ? "Category" : "قسم"}
//                         </h6>
//                         {expandedSections.category ? (
//                           <ChevronUp size={18} />
//                         ) : (
//                           <ChevronDown size={18} />
//                         )}
//                       </button>
//                       {expandedSections.category && (
//                         <div className="filter-collapse">
//                           {filterOptions.categories.map((category) => (
//                             <div key={category.id} className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 id={`category-${category.id}`}
//                                 checked={filters.categoryIds.includes(
//                                   category.id,
//                                 )}
//                                 onChange={() =>
//                                   toggleFilter("categoryIds", category.id)
//                                 }
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor={`category-${category.id}`}
//                               >
//                                 {category.name}
//                               </label>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {/* Sub Category Filter */}
//                   {filterOptions.subCategories.length > 0 && (
//                     <div className="filter-section">
//                       <button
//                         onClick={() => toggleSection("subCategory")}
//                         className={`filter-section-header ${expandedSections.subCategory ? "expanded" : ""}`}
//                       >
//                         <h6 className="filter-section-title">
//                           {lang === "EN" ? "Sub Category" : "فئة"}
//                         </h6>
//                         {expandedSections.subCategory ? (
//                           <ChevronUp size={18} />
//                         ) : (
//                           <ChevronDown size={18} />
//                         )}
//                       </button>
//                       {expandedSections.subCategory && (
//                         <div className="filter-collapse">
//                           {filterOptions.subCategories.map((subCategory) => (
//                             <div key={subCategory.id} className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 id={`subCategory-${subCategory.id}`}
//                                 checked={filters.subCategoryIds.includes(
//                                   subCategory.id,
//                                 )}
//                                 onChange={() =>
//                                   toggleFilter("subCategoryIds", subCategory.id)
//                                 }
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor={`subCategory-${subCategory.id}`}
//                               >
//                                 {subCategory.name}
//                               </label>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {/* Brand Filter */}
//                   {filterOptions.brands.length > 0 && (
//                     <div className="filter-section">
//                       <button
//                         onClick={() => toggleSection("brand")}
//                         className={`filter-section-header ${expandedSections.brand ? "expanded" : ""}`}
//                       >
//                         <h6 className="filter-section-title">
//                           {lang === "EN" ? "Brand" : "ماركة"}
//                         </h6>
//                         {expandedSections.brand ? (
//                           <ChevronUp size={18} />
//                         ) : (
//                           <ChevronDown size={18} />
//                         )}
//                       </button>
//                       {expandedSections.brand && (
//                         <div className="filter-collapse">
//                           {filterOptions.brands.map((brand) => (
//                             <div key={brand.id} className="form-check">
//                               <input
//                                 className="form-check-input"
//                                 type="checkbox"
//                                 id={`brand-${brand.id}`}
//                                 checked={filters.brandIds.includes(brand.id)}
//                                 onChange={() =>
//                                   toggleFilter("brandIds", brand.id)
//                                 }
//                               />
//                               <label
//                                 className="form-check-label"
//                                 htmlFor={`brand-${brand.id}`}
//                               >
//                                 {brand.nameEn}
//                               </label>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {/* Color Filter */}
//                   {filterOptions.colors.length > 0 && (
//                     <div className="filter-section">
//                       <button
//                         onClick={() => toggleSection("color")}
//                         className={`filter-section-header ${expandedSections.color ? "expanded" : ""}`}
//                       >
//                         <h6 className="filter-section-title">
//                           {lang === "EN" ? "Color" : "لون"}
//                         </h6>
//                         {expandedSections.color ? (
//                           <ChevronUp size={18} />
//                         ) : (
//                           <ChevronDown size={18} />
//                         )}
//                       </button>
//                       {expandedSections.color && (
//                         <div className="filter-collapse">
//                           <div className="color-options-grid">
//                             {filterOptions.colors.map((color) => (
//                               <div
//                                 key={color.id}
//                                 className={`color-option ${filters.colorIds.includes(color.id) ? "selected" : ""}`}
//                                 style={{ backgroundColor: color.hexCode }}
//                                 onClick={() =>
//                                   toggleFilter("colorIds", color.id)
//                                 }
//                                 title={color.nameEn || "Color"}
//                               />
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {/* Size Filter */}
//                   {filterOptions.sizes.length > 0 && (
//                     <div className="filter-section">
//                       <button
//                         onClick={() => toggleSection("size")}
//                         className={`filter-section-header ${expandedSections.size ? "expanded" : ""}`}
//                       >
//                         <h6 className="filter-section-title">
//                           {lang === "EN" ? "Size" : "مقاس"}
//                         </h6>
//                         {expandedSections.size ? (
//                           <ChevronUp size={18} />
//                         ) : (
//                           <ChevronDown size={18} />
//                         )}
//                       </button>
//                       {expandedSections.size && (
//                         <div className="filter-collapse">
//                           <div className="size-options-grid">
//                             {filterOptions.sizes.map((size) => (
//                               <div
//                                 key={size.id}
//                                 className={`size-option ${filters.sizeIds.includes(size.id) ? "selected" : ""}`}
//                                 onClick={() => toggleFilter("sizeIds", size.id)}
//                               >
//                                 {size.nameEn}
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Products Grid */}
//           <div className={showFilters ? "col-lg-9" : "col-12"}>
//             {/* Mobile Filter Toggle */}
//             <button
//               onClick={() => setShowFilters(!showFilters)}
//               className="mobile-filter-toggle"
//             >
//               <Filter size={18} />
//               {showFilters
//                 ? lang === "EN"
//                   ? "Hide Filters"
//                   : "إخفاء الفلاتر"
//                 : lang === "EN"
//                   ? "Show Filters"
//                   : "إظهار الفلاتر"}
//             </button>

//             {/* Top Controls */}
//             <div className="top-controls">
//               <div className="results-count">
//                 <span>{pagination.totalCount}</span>{" "}
//                 {lang === "EN" ? "Products" : "منتج"}
//               </div>
//               <select
//                 className="sort-select"
//                 value={filters.sortBy}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, sortBy: e.target.value }))
//                 }
//               >
//                 <option value="newest">
//                   {lang === "EN" ? "Newest First" : "الأحدث أولاً"}
//                 </option>
//                 <option value="oldest">
//                   {lang === "EN" ? "Oldest First" : "الأقدم أولاً"}
//                 </option>
//                 <option value="price-low">
//                   {lang === "EN"
//                     ? "Price: Low to High"
//                     : "السعر: من الأقل إلى الأعلى"}
//                 </option>
//                 <option value="price-high">
//                   {lang === "EN"
//                     ? "Price: High to Low"
//                     : "السعر: من الأعلى إلى الأقل"}
//                 </option>
//               </select>
//             </div>

//             {/* Loading State */}
//             {loading ? (
//               <div className="loading-container">
//                 <Loader className="loader-spin" size={48} />
//               </div>
//             ) : products?.length === 0 ? (
//               // Empty State
//               <div className="empty-state">
//                 <X size={64} />
//                 <h3>
//                   {lang === "EN" ? "No products found" : "لا يتوفر منتجات"}
//                 </h3>
//                 <p>
//                   {lang === "EN"
//                     ? "Try adjusting your filters"
//                     : "يمكنك البحث عن منتجات أخري"}
//                 </p>
//                 <button onClick={clearAllFilters} className="btn">
//                   {lang === "EN" ? "Clear all filters" : "أمسح الفلتر"}
//                 </button>
//               </div>
//             ) : (
//               <>
//                 {/* Products Grid */}
//                 <div className="row g-4 products-grid-container">
//                   {products?.map((product) => {
//                     const minPrice = product?.variants
//                       ? Math.min(
//                           ...product?.variants?.map(
//                             (v) => v.discountPrice || v.price,
//                           ),
//                         )
//                       : 0;
//                     const maxPrice = product?.variants
//                       ? Math.max(...product?.variants?.map((v) => v.price))
//                       : 0;
//                     const hasDiscount = product?.variants
//                       ? product?.variants?.some((v) => v.discountPrice)
//                       : 0;
//                     const availableColors = product?.variants
//                       ? [
//                           ...new Set(
//                             product?.variants
//                               ?.map((v) => v.color?.hexCode)
//                               .filter(Boolean),
//                           ),
//                         ]
//                       : [];
//                     const availableSizes = product?.variants
//                       ? [
//                           ...new Set(
//                             product?.variants
//                               ?.map((v) => v.size?.nameEn)
//                               .filter(Boolean),
//                           ),
//                         ]
//                       : [];

//                     const productCartState = cartStates[product.id] || {
//                       isAdding: false,
//                       showSuccess: false,
//                     };

//                     return (
//                       <div key={product?.id} className="col-md-6 col-xl-4">
//                         <Link
//                           to={openProductProfile(product)}
//                           style={{ textDecoration: "none" }}
//                         >
//                           <div className="card product-card h-100 shadow-sm border-0">
//                             {/* Product Image Section */}
//                             <div className="product-image-wrapper">
//                               <img
//                                 src={
//                                   product?.primaryImageUrl ||
//                                   "https://via.placeholder.com/400"
//                                 }
//                                 alt={product?.nameEn}
//                                 className="product-image"
//                               />

//                               {/* Out of Stock Overlay */}
//                               {isProductOutOfStock(product) && (
//                                 <div className="out-of-stock-overlay">
//                                   <div className="out-of-stock-badge">
//                                     {lang === "EN"
//                                       ? "OUT OF STOCK"
//                                       : "غير متوفر"}
//                                   </div>
//                                 </div>
//                               )}

//                               {/* Brand Badge */}
//                               {product?.brand?.imageUrl && (
//                                 <div className="brand-badge">
//                                   <img
//                                     src={product?.brand?.imageUrl}
//                                     alt={product?.brand?.nameEn}
//                                     className="brand-logo"
//                                   />
//                                 </div>
//                               )}

//                               {/* Status Badges */}
//                               <div className="badge-overlay">
//                                 {product?.isNew && (
//                                   <span className="badge bg-success badge-tag">
//                                     {lang === "EN" ? "NEW" : "جديد"}
//                                   </span>
//                                 )}
//                                 {product?.isTrend && (
//                                   <span
//                                     className="badge badge-tag"
//                                     style={{
//                                       backgroundColor: "#6f42c1",
//                                       color: "white",
//                                     }}
//                                   >
//                                     {lang === "EN" ? "TRENDING" : "ترند"}
//                                   </span>
//                                 )}
//                                 {product?.isTopSeller && (
//                                   <span className="badge bg-warning text-dark badge-tag">
//                                     {lang === "EN"
//                                       ? "TOP SELLER"
//                                       : "أكثر مبيعا"}
//                                   </span>
//                                 )}
//                               </div>

//                               {/* Sale Badge */}
//                               {hasDiscount && (
//                                 <span className="badge bg-danger sale-badge badge-tag">
//                                   {lang === "EN" ? "SALE" : "تخفيض"}
//                                 </span>
//                               )}

//                               {/* Fixed Add to Cart Button */}
//                               <button
//                                 className={`fixed-cart-btn ${productCartState.isAdding ? "loading" : ""} ${productCartState.showSuccess ? "added" : ""}`}
//                                 onClick={(e) => handleAddToCart(e, product)}
//                                 disabled={
//                                   productCartState.isAdding ||
//                                   isProductOutOfStock(product)
//                                 }
//                               >
//                                 <FaShoppingBag size={18} />
//                               </button>
//                               {/* Wishlist Button */}
//                             {(() => {
//                               const availableVariant = product.variants.find(
//                                 v => (v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0)
//                               ) || product.variants[0];
                              
//                               return (
//                                 <div onClick={(e) => e.preventDefault()}>
//                                   <WishlistButton 
//                                     productVariantId={availableVariant.id}
//                                     className="fixed-wishlist-btn"
//                                   />
//                                 </div>
//                               );
//                             })()}
//                             </div>

//                             {/* Product Info Section */}
//                             <div className="card-body">
//                               {/* Brand Name */}
//                               <p className="product-brand-text mb-1">
//                                 {product?.brand?.nameEn}
//                               </p>

//                               {/* Product Title */}
//                               <h5 className="product-title">
//                                 {lang === "EN"
//                                   ? product?.nameEn
//                                   : product?.nameAr}
//                               </h5>

//                               {/* Product Description */}
//                               <p className="product-description">
//                                 {lang === "EN"
//                                   ? product?.descriptionEn
//                                   : product?.descriptionAr}
//                               </p>

//                               {/* Available Colors */}
//                               {availableColors.length > 0 && (
//                                 <div className="product-colors-display">
//                                   {availableColors
//                                     .slice(0, 5)
//                                     .map((color, i) => (
//                                       <div
//                                         key={i}
//                                         className="color-dot"
//                                         style={{
//                                           backgroundColor: color,
//                                         }}
//                                       />
//                                     ))}
//                                   {availableColors.length > 5 && (
//                                     <span className="color-count">
//                                       +{availableColors.length - 5}
//                                     </span>
//                                   )}
//                                 </div>
//                               )}

//                               {/* Available Sizes */}
//                               {availableSizes.length > 0 && (
//                                 <div className="product-sizes-display">
//                                   {availableSizes.slice(0, 5).map((size, i) => (
//                                     <span key={i} className="size-badge">
//                                       {size}
//                                     </span>
//                                   ))}
//                                   {availableSizes.length > 5 && (
//                                     <span className="size-count">
//                                       +{availableSizes.length - 5}
//                                     </span>
//                                   )}
//                                 </div>
//                               )}

//                               {/* Price Section */}
//                               <div className="price-section">
//                                 <span className="price-badge">
//                                   EGP {minPrice.toFixed(0)}
//                                 </span>
//                                 {minPrice !== maxPrice && (
//                                   <>
//                                     <span className="text-muted">-</span>
//                                     <span className="price-badge">
//                                       {maxPrice.toFixed(0)}
//                                     </span>
//                                   </>
//                                 )}
//                                 {hasDiscount && (
//                                   <span className="original-price">
//                                     EGP {maxPrice.toFixed(0)}
//                                   </span>
//                                 )}
//                               </div>

//                               {/* View Details Button */}
//                               <div className="d-flex gap-2">
//                                 <button className="btn flex-grow-1 view-details-btn text-light">
//                                   {lang === "EN"
//                                     ? "View Details"
//                                     : "تفاصيل المنتج"}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </Link>
//                       </div>
//                     );
//                   })}
//                 </div>

//                 {/* ✅ Infinite Scroll Trigger & Loader */}
//                 {hasMoreProducts && (
//                   <div 
//                     ref={observerTarget} 
//                     className="infinite-scroll-trigger"
//                   >
//                     {loadingMore && (
//                       <div className="loading-more-container">
//                         <Loader className="loader-spin" size={32} />
//                         <p className="loading-more-text">
//                           {lang === "EN" ? "Loading more..." : "جاري تحميل المزيد..."}
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductsCollectionList;


// import { useState, useEffect, useMemo, useCallback, useRef } from "react";
// import { Filter, X, ChevronDown, ChevronUp, Loader, Check } from "lucide-react";
// import { FaShoppingBag } from "react-icons/fa";
// import "./ProductsCollectionList.scss";
// import ProductsApiService from "../../services/ProductsApiService";
// import { Link, useLocation, useParams } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import { useCart } from "../../context/CartContext";
// import { getLanguage } from "../../utils/Helper";
// import { toast } from "react-toastify";
// import WishlistButton from "../../components/general/wishlistButton/WishlistButton";

// const ProductsCollectionList = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [, setError] = useState(null);
//   const [colorsAndSizes, setColorsAndSizes] = useState(null);
//   const lang = getLanguage();

//   const { collectionName, categoryName } = useParams();
//   const location = useLocation();
//   const authContext = useAuth();
//   const { addToCart } = useCart();

//   const [cartStates, setCartStates] = useState({});
//   const addToCartTimeoutRefs = useRef({});
  
//   const observerTarget = useRef(null);
//   const isFirstLoad = useRef(true);
//   const isFetchingRef = useRef(false);

//   // ✨ NEW: Modal States
//   const [showFilterModal, setShowFilterModal] = useState(false);
//   const [showSortModal, setShowSortModal] = useState(false);

//   const queryParams = new URLSearchParams(location.search);
//   const subCategoriesParams = queryParams.get("sub_cat")
//     ? queryParams.get("sub_cat").split(",")
//     : [];
//   const brandsParams = queryParams.get("brand")
//     ? queryParams.get("brand").split(",")
//     : [];

//   const [currentCollection, setCurrentCollection] = useState(null);
//   const [, setActiveCategory] = useState(null);

//   const [pagination, setPagination] = useState({
//     currentPage: 0,
//     pageSize: 10,
//     totalCount: 0,
//     totalPages: 0,
//   });

//   const [filters, setFilters] = useState({
//     collectionId: currentCollection?.id,
//     categoryIds: [],
//     subCategoryIds: [],
//     brandIds: [],
//     colorIds: [],
//     sizeIds: [],
//     minPrice: null,
//     maxPrice: null,
//     search: "",
//     isNew: null,
//     isTrend: null,
//     isTopSeller: null,
//     sortBy: "newest",
//   });

//   const [showFilters, setShowFilters] = useState(true);
//   const [expandedSections, setExpandedSections] = useState({
//     category: true,
//     subCategory: false,
//     brand: false,
//     color: false,
//     size: false,
//     status: true,
//   });

//   const filterOptions = useMemo(() => {
//     if (!currentCollection || !colorsAndSizes)
//       return {
//         categories: [],
//         subCategories: [],
//         brands: [],
//         colors: [],
//         sizes: [],
//       };

//     const categories = new Map();
//     const subCategories = new Map();
//     const brands = new Map();
//     const colors = new Map();
//     const sizes = new Map();

//     currentCollection?.categories.forEach((cat) => {
//       if (cat) categories.set(cat?.id, { ...cat, nameEn: cat.name_url });
//       cat?.sub_categories.forEach((sub) => {
//         if (sub)
//           subCategories.set(sub?.id, {
//             ...sub,
//             nameEn: sub.name_url,
//             categoryId: cat.id,
//           });
//       });
//     });

//     currentCollection?.top_brands.forEach((brand) => {
//       if (brand) {
//         brands.set(brand?.id, { ...brand, nameEn: brand.name_url });
//       }
//     });

//     colorsAndSizes?.colors.forEach((color) => {
//       if (color) colors.set(color.id, color);
//     });

//     colorsAndSizes?.sizes.forEach((size) => {
//       if (size) sizes.set(size.id, size);
//     });

//     let filteredSubCategories = Array.from(subCategories.values());
//     if (filters.categoryIds.length > 0) {
//       filteredSubCategories = filteredSubCategories.filter((sub) =>
//         filters.categoryIds.includes(sub.categoryId),
//       );
//     }

//     return {
//       categories: Array.from(categories.values()),
//       subCategories: filteredSubCategories,
//       brands: Array.from(brands.values()),
//       colors: Array.from(colors.values()),
//       sizes: Array.from(sizes.values()),
//     };
//   }, [currentCollection, colorsAndSizes, filters.categoryIds]);

//   const fetchProducts = async (isLoadMore = false) => {
//     if (!currentCollection || !colorsAndSizes) return;

//     try {
//       if (isLoadMore) {
//         setLoadingMore(true);
//       } else {
//         setLoading(true);
//       }
//       setError(null);
//       const queryParams = new URLSearchParams();
//       queryParams.append("page", pagination.currentPage);
//       queryParams.append("limit", pagination.pageSize);

//       queryParams.append("collectionId", currentCollection?.id);
//       if (filters.categoryIds.length)
//         filters.categoryIds.forEach((id) =>
//           queryParams.append("categoryIds", id),
//         );
//       if (filters.subCategoryIds.length)
//         filters.subCategoryIds.forEach((id) =>
//           queryParams.append("subCategoryIds", id),
//         );
//       if (filters.brandIds.length)
//         filters.brandIds.forEach((id) => queryParams.append("brandIds", id));
//       if (filters.colorIds.length)
//         filters.colorIds.forEach((id) => queryParams.append("colorIds", id));
//       if (filters.sizeIds.length)
//         filters.sizeIds.forEach((id) => queryParams.append("sizeIds", id));
//       if (filters.minPrice) queryParams.append("minPrice", filters.minPrice);
//       if (filters.maxPrice) queryParams.append("maxPrice", filters.maxPrice);
//       if (filters.search) queryParams.append("search", filters.search);
//       if (filters.isNew !== null) queryParams.append("isNew", filters.isNew);
//       if (filters.isTrend !== null)
//         queryParams.append("isTrend", filters.isTrend);
//       if (filters.isTopSeller !== null)
//         queryParams.append("isTopSeller", filters.isTopSeller);
//       queryParams.append("sortBy", filters.sortBy);

//       const response =
//         await ProductsApiService.getProductsListWithFilters(queryParams);

//       if (isLoadMore) {
//         setProducts((prev) => {
//           const existingIds = new Set(prev.map(p => p.id));
//           const newProducts = (response.products || []).filter(
//             product => !existingIds.has(product.id)
//           );
//           return [...prev, ...newProducts];
//         });
//       } else {
//         setProducts(response.products || []);
//       }

//       setPagination({
//         currentPage: response.currentPage,
//         pageSize: response.pageSize,
//         totalCount: response.totalCount,
//         totalPages: response.totalPages,
//       });
//     } catch (err) {
//       setError(err.message);
//       setPagination({
//         currentPage: 0,
//         pageSize: 10,
//         totalCount: 0,
//         totalPages: 0,
//       });
//     } finally {
//       setLoading(false);
//       setLoadingMore(false);
//     }
//   };

//   const handleLoadMore = useCallback(() => {
//     if (loadingMore || loading || isFetchingRef.current) return;
//     if (pagination.currentPage >= pagination.totalPages - 1) return;
    
//     isFetchingRef.current = true;
//     setPagination((prev) => ({ ...prev, currentPage: prev.currentPage + 1 }));
//   }, [loadingMore, loading, pagination.currentPage, pagination.totalPages]);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         const target = entries[0];
        
//         if (
//           target.isIntersecting && 
//           !loadingMore && 
//           !loading && 
//           !isFetchingRef.current &&
//           pagination.currentPage < pagination.totalPages - 1
//         ) {
//           handleLoadMore();
//         }
//       },
//       {
//         root: null,
//         rootMargin: "200px",
//         threshold: 0.1,
//       }
//     );

//     const currentTarget = observerTarget.current;
//     if (currentTarget) {
//       observer.observe(currentTarget);
//     }

//     return () => {
//       if (currentTarget) {
//         observer.unobserve(currentTarget);
//       }
//     };
//   }, [handleLoadMore, loadingMore, loading, pagination.currentPage, pagination.totalPages]);

//   function loadCollectionsData() {
//     if (!authContext?.systemCollections?.length) return;

//     const collection = authContext.systemCollections.find(
//       (col) =>
//         col.name_url.toLowerCase().trim() ===
//         collectionName.split("-").join(" ").toLowerCase().trim(),
//     );
//     if (!collection) return;

//     setCurrentCollection(collection);

//     if (categoryName) {
//       const category = collection.categories.find(
//         (cat) =>
//           cat.name_url.toLowerCase().trim() ===
//           categoryName.split("-").join(" ").toLowerCase().trim(),
//       );
//       setActiveCategory(category);

//       const selectedSubIds =
//         category?.sub_categories
//           .filter((subCat) =>
//             subCategoriesParams.some(
//               (name) =>
//                 subCat.name_url.toLowerCase().trim() ===
//                 name.split("-").join(" ").toLowerCase().trim(),
//             ),
//           )
//           .map((sub) => sub.id) || [];

//       setFilters((prev) => ({
//         ...prev,
//         collectionId: collection.id,
//         categoryIds: category ? [category.id] : [],
//         subCategoryIds: selectedSubIds,
//         brandIds:
//           collection?.top_brands
//             ?.filter((brand) =>
//               brandsParams.some(
//                 (name) =>
//                   brand.name_url.toLowerCase().trim() ===
//                   name.split("-").join(" ").toLowerCase().trim(),
//               ),
//             )
//             .map((br) => br.id) || [],
//       }));
//     } else {
//       setFilters((prev) => ({
//         ...prev,
//         categoryIds: [],
//         subCategoryIds: [],
//         collectionId: collection.id,
//         brandIds:
//           collection?.top_brands
//             ?.filter((brand) =>
//               brandsParams.some(
//                 (name) =>
//                   brand.name_url.toLowerCase().trim() ===
//                   name.split("-").join(" ").toLowerCase().trim(),
//               ),
//             )
//             .map((br) => br.id) || [],
//       }));
//     }
//   }

//   async function fetchColorsAndSizes() {
//     try {
//       if (colorsAndSizes?.colors && colorsAndSizes?.sizes) return;
//       const response = await ProductsApiService.getColorsAndSizesByFilters({
//         collectionId: currentCollection?.id,
//         categoryIds: filters.categoryIds?.join(","),
//         subCategoryIds: filters.subCategoryIds?.join(","),
//         brandIds: filters.brandIds?.join(","),
//       });
//       setColorsAndSizes(response);
//     } catch (err) {
//       console.error("Error fetching colors and sizes:", err);
//     }
//   }

//   const isProductOutOfStock = useCallback((product) => {
//     if (!product.variants || product.variants.length === 0) {
//       return true;
//     }

//     let outOfStock = true;
//     product.variants.forEach((v) => {
//       if ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0)) {
//         outOfStock = false;
//         return;
//       }
//     });

//     return outOfStock;
//   }, []);

//   const handleAddToCart = useCallback(
//     async (e, product) => {
//       e.preventDefault();
//       e.stopPropagation();

//       if (isProductOutOfStock(product)) {
//         toast.warning(
//           lang === "EN" ? "Product is out of stock" : "المنتج غير متوفر حالياً",
//         );
//         return;
//       }

//       const productId = product.id;

//       if (cartStates[productId]?.isAdding) return;

//       if (addToCartTimeoutRefs.current[productId]) {
//         clearTimeout(addToCartTimeoutRefs.current[productId]);
//       }

//       setCartStates((prev) => ({
//         ...prev,
//         [productId]: { isAdding: true, showSuccess: false },
//       }));

//       try {
//         if (product.variants && product.variants.length > 0) {
//           const apiVariant = product.variants.find(
//             (v) => (v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0),
//           ) || product.variants[0];

//           const variant = {
//             id: apiVariant.id,
//             productId: apiVariant.productId,
//             color: apiVariant.color,
//             size: apiVariant.size,
//             price:
//               typeof apiVariant.price === "object"
//                 ? apiVariant.price.parsedValue
//                 : apiVariant.price,
//             discountPrice:
//               apiVariant.discountPrice &&
//               typeof apiVariant.discountPrice === "object"
//                 ? apiVariant.discountPrice.parsedValue
//                 : apiVariant.discountPrice,
//             quantity: apiVariant.quantity,
//             reservedQuantity: apiVariant.reservedQuantity,
//             withoutBoxQuantity: apiVariant.withoutBoxQuantity,
//             withoutBoxReservedQuantity: apiVariant.withoutBoxReservedQuantity,
//             stockStatus: apiVariant.stockStatus || "In Stock",
//           };

//           const cartProduct = {
//             id: product.id,
//             nameEn: product.nameEn,
//             nameAr: product.nameAr,
//             descriptionEn: product.descriptionEn,
//             descriptionAr: product.descriptionAr,
//             images: [{ image_url: product.primaryImageUrl }],
//             brand: {
//               nameEn: product.brand?.nameEn,
//               nameAr: product.brand?.nameAr,
//             },
//             collection: { nameEn: product.collection?.nameEn },
//             category: { nameEn: product.category?.nameEn },
//             subCategory: { nameEn: product.subCategory?.nameEn },
//           };

//           await addToCart(cartProduct, variant, 1, ((apiVariant.quantity - apiVariant.reservedQuantity > 0)? false: true), false);

//           setCartStates((prev) => ({
//             ...prev,
//             [productId]: { isAdding: false, showSuccess: true },
//           }));

//           addToCartTimeoutRefs.current[productId] = setTimeout(() => {
//             setCartStates((prev) => ({
//               ...prev,
//               [productId]: { isAdding: false, showSuccess: false },
//             }));
//           }, 2000);
//         } else {
//           toast.error(
//             lang === "EN"
//               ? "This product has no available variants"
//               : "هذا المنتج ليس له مقاسات متاحة",
//           );
//           setCartStates((prev) => ({
//             ...prev,
//             [productId]: { isAdding: false, showSuccess: false },
//           }));
//         }
//       } catch (error) {
//         console.error("Error adding to cart:", error);
//         toast.error(
//           lang === "EN"
//             ? "Something went wrong while adding to cart"
//             : "حدث خطأ أثناء إضافة المنتج للسلة",
//         );
//         setCartStates((prev) => ({
//           ...prev,
//           [productId]: { isAdding: false, showSuccess: false },
//         }));
//       }
//     },
//     [addToCart, cartStates, lang, isProductOutOfStock],
//   );

//   useEffect(() => {
//     if (
//       currentCollection &&
//       colorsAndSizes &&
//       pagination?.currentPage !== null
//     ) {
//       const isLoadMore = pagination.currentPage > 0;
//       fetchProducts(isLoadMore).finally(() => {
//         isFetchingRef.current = false;
//       });
      
//       if (isFirstLoad.current && !isLoadMore) {
//         isFirstLoad.current = false;
//       }
//     }
//   }, [pagination.currentPage, currentCollection, colorsAndSizes]);

//   useEffect(() => {
//     setColorsAndSizes(null);
//     loadCollectionsData();
//   }, [authContext, collectionName, categoryName]);

//   useEffect(() => {
//     if (currentCollection) {
//       fetchColorsAndSizes();
//     }
//   }, [currentCollection, collectionName]);

//   useEffect(() => {
//     const debounceTimer = setTimeout(() => {
//       isFirstLoad.current = true;
      
//       if (pagination.currentPage === 0) {
//         fetchProducts(false);
//       } else {
//         setPagination((prev) => ({ ...prev, currentPage: 0 }));
//         setProducts([]);
//       }
//     }, 1000);

//     return () => clearTimeout(debounceTimer);
//   }, [filters]);

//   const toggleFilter = (filterType, id) => {
//     setFilters((prev) => {
//       const newFilters = {
//         ...prev,
//         [filterType]: prev[filterType].includes(id)
//           ? prev[filterType].filter((item) => item !== id)
//           : [...prev[filterType], id],
//       };

//       if (filterType === "categoryIds" && prev[filterType].includes(id)) {
//         const subCatsToRemove = filterOptions.subCategories
//           .filter((sub) => sub.categoryId === id)
//           .map((sub) => sub.id);

//         newFilters.subCategoryIds = prev.subCategoryIds.filter(
//           (subId) => !subCatsToRemove.includes(subId),
//         );
//       }

//       return newFilters;
//     });
//   };

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
//   };

//   const toggleStatusFilter = (statusType) => {
//     setFilters((prev) => ({
//       ...prev,
//       [statusType]: prev[statusType] ? null : true,
//     }));
//   };

//   const clearAllFilters = () => {
//     setFilters({
//       categoryIds: [],
//       subCategoryIds: [],
//       brandIds: [],
//       colorIds: [],
//       sizeIds: [],
//       minPrice: null,
//       maxPrice: null,
//       search: "",
//       isNew: null,
//       isTrend: null,
//       isTopSeller: null,
//       sortBy: "newest",
//     });
//   };

//   const activeFiltersCount =
//     filters.categoryIds.length +
//     filters.subCategoryIds.length +
//     filters.brandIds.length +
//     filters.colorIds.length +
//     filters.sizeIds.length +
//     (filters.isNew ? 1 : 0) +
//     (filters.isTrend ? 1 : 0) +
//     (filters.isTopSeller ? 1 : 0);

//   const openProductProfile = (pro) => {
//     const collectionName = pro.collection.nameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     const catName = pro.category.nameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     const subCatName = pro.subCategory.nameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     return `/collection/${collectionName}/${catName}/${subCatName}/${pro.id}`;
//   };

//   const hasMoreProducts = pagination.currentPage < pagination.totalPages - 1;

//   // ✨ Sort Options
//   const sortOptions = [
//     { value: "newest", label: lang === "EN" ? "Newest First" : "الأحدث أولاً" },
//     { value: "oldest", label: lang === "EN" ? "Oldest First" : "الأقدم أولاً" },
//     { value: "price-low", label: lang === "EN" ? "Price: Low to High" : "السعر: من الأقل إلى الأعلى" },
//     { value: "price-high", label: lang === "EN" ? "Price: High to Low" : "السعر: من الأعلى إلى الأقل" },
//   ];

//   // ✨ Apply Filters (close modal and apply)
//   const applyFilters = () => {
//     setShowFilterModal(false);
//     // Filters already applied through toggleFilter
//   };

//   // ✨ Apply Sort (close modal and apply)
//   const applySort = (sortValue) => {
//     setFilters((prev) => ({ ...prev, sortBy: sortValue }));
//     setShowSortModal(false);
//   };

//   return (
//     <div className="min-vh-100 pb-4 products-collection-page" style={{ paddingTop: "140px" }}>
//       <div className="container-fluid py-3 px-lg-5">
//         {/* Collection Hero Image */}
//         <div className="col-12 mb-4">
//           <img
//             src={currentCollection?.image_url}
//             alt=""
//             className="collection-image-section"
//           />
//         </div>

//         <div className="row g-4">
//           {/* Desktop Filters Sidebar */}
//           {showFilters && (
//             <div className="col-lg-3 desktop-filters">
//               <div className="card shadow-sm filters-sidebar">
//                 <div className="card-body">
//                   {/* Filter Header */}
//                   <div className="filter-header">
//                     <div className="filter-title">
//                       <Filter size={20} />
//                       <span>{lang === "EN" ? "Filters" : "الفلاتر"}</span>
//                       {activeFiltersCount > 0 && (
//                         <span className="filter-count">
//                           {activeFiltersCount}
//                         </span>
//                       )}
//                     </div>
//                     {activeFiltersCount > 0 && (
//                       <button
//                         onClick={clearAllFilters}
//                         className="clear-filters-btn"
//                       >
//                         {lang === "EN" ? "Clear all" : "مسح الكل"}
//                       </button>
//                     )}
//                   </div>

//                   {/* Filter Sections */}
//                   <FilterSections
//                     expandedSections={expandedSections}
//                     toggleSection={toggleSection}
//                     filters={filters}
//                     toggleStatusFilter={toggleStatusFilter}
//                     filterOptions={filterOptions}
//                     toggleFilter={toggleFilter}
//                     lang={lang}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Products Grid */}
//           <div className={showFilters ? "col-lg-9" : "col-12"}>
//             {/* Desktop Top Controls */}
//             <div className="top-controls desktop-only">
//               <div className="results-count">
//                 <span>{pagination.totalCount}</span>{" "}
//                 {lang === "EN" ? "Products" : "منتج"}
//               </div>
//               <select
//                 className="sort-select"
//                 value={filters.sortBy}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, sortBy: e.target.value }))
//                 }
//               >
//                 {sortOptions.map(opt => (
//                   <option key={opt.value} value={opt.value}>{opt.label}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Loading State */}
//             {loading ? (
//               <div className="loading-container">
//                 <Loader className="loader-spin" size={48} />
//               </div>
//             ) : products?.length === 0 ? (
//               // Empty State
//               <div className="empty-state">
//                 <X size={64} />
//                 <h3>
//                   {lang === "EN" ? "No products found" : "لا يتوفر منتجات"}
//                 </h3>
//                 <p>
//                   {lang === "EN"
//                     ? "Try adjusting your filters"
//                     : "يمكنك البحث عن منتجات أخري"}
//                 </p>
//                 <button onClick={clearAllFilters} className="btn">
//                   {lang === "EN" ? "Clear all filters" : "أمسح الفلتر"}
//                 </button>
//               </div>
//             ) : (
//               <>
//                 {/* Products Grid */}
//                 <div className="row g-4 products-grid-container">
//                   {products?.map((product) => {
//                     const minPrice = product?.variants
//                       ? Math.min(
//                           ...product?.variants?.map(
//                             (v) => v.discountPrice || v.price,
//                           ),
//                         )
//                       : 0;
//                     const maxPrice = product?.variants
//                       ? Math.max(...product?.variants?.map((v) => v.price))
//                       : 0;
//                     const hasDiscount = product?.variants
//                       ? product?.variants?.some((v) => v.discountPrice)
//                       : 0;
//                     const availableColors = product?.variants
//                       ? [
//                           ...new Set(
//                             product?.variants
//                               ?.map((v) => v.color?.hexCode)
//                               .filter(Boolean),
//                           ),
//                         ]
//                       : [];
//                     const availableSizes = product?.variants
//                       ? [
//                           ...new Set(
//                             product?.variants
//                               ?.map((v) => v.size?.nameEn)
//                               .filter(Boolean),
//                           ),
//                         ]
//                       : [];

//                     const productCartState = cartStates[product.id] || {
//                       isAdding: false,
//                       showSuccess: false,
//                     };

//                     return (
//                       <div key={product?.id} className="col-md-6 col-xl-4">
//                         <Link
//                           to={openProductProfile(product)}
//                           style={{ textDecoration: "none" }}
//                         >
//                           <div className="card product-card h-100 shadow-sm border-0">
//                             {/* Product Image Section */}
//                             <div className="product-image-wrapper">
//                               <img
//                                 src={
//                                   product?.primaryImageUrl ||
//                                   "https://via.placeholder.com/400"
//                                 }
//                                 alt={product?.nameEn}
//                                 className="product-image"
//                               />

//                               {/* Out of Stock Overlay */}
//                               {isProductOutOfStock(product) && (
//                                 <div className="out-of-stock-overlay">
//                                   <div className="out-of-stock-badge">
//                                     {lang === "EN"
//                                       ? "OUT OF STOCK"
//                                       : "غير متوفر"}
//                                   </div>
//                                 </div>
//                               )}

//                               {/* Brand Badge */}
//                               {product?.brand?.imageUrl && (
//                                 <div className="brand-badge">
//                                   <img
//                                     src={product?.brand?.imageUrl}
//                                     alt={product?.brand?.nameEn}
//                                     className="brand-logo"
//                                   />
//                                 </div>
//                               )}

//                               {/* Status Badges */}
//                               <div className="badge-overlay">
//                                 {product?.isNew && (
//                                   <span className="badge bg-success badge-tag">
//                                     {lang === "EN" ? "NEW" : "جديد"}
//                                   </span>
//                                 )}
//                                 {product?.isTrend && (
//                                   <span
//                                     className="badge badge-tag"
//                                     style={{
//                                       backgroundColor: "#6f42c1",
//                                       color: "white",
//                                     }}
//                                   >
//                                     {lang === "EN" ? "TRENDING" : "ترند"}
//                                   </span>
//                                 )}
//                                 {product?.isTopSeller && (
//                                   <span className="badge bg-warning text-dark badge-tag">
//                                     {lang === "EN"
//                                       ? "TOP SELLER"
//                                       : "أكثر مبيعا"}
//                                   </span>
//                                 )}
//                               </div>

//                               {/* Sale Badge */}
//                               {hasDiscount && (
//                                 <span className="badge bg-danger sale-badge badge-tag">
//                                   {lang === "EN" ? "SALE" : "تخفيض"}
//                                 </span>
//                               )}

//                               {/* Fixed Add to Cart Button */}
//                               <button
//                                 className={`fixed-cart-btn ${productCartState.isAdding ? "loading" : ""} ${productCartState.showSuccess ? "added" : ""}`}
//                                 onClick={(e) => handleAddToCart(e, product)}
//                                 disabled={
//                                   productCartState.isAdding ||
//                                   isProductOutOfStock(product)
//                                 }
//                               >
//                                 <FaShoppingBag size={18} />
//                               </button>

//                               {/* Wishlist Button */}
//                               {(() => {
//                                 const availableVariant = product.variants.find(
//                                   v => (v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0)
//                                 ) || product.variants[0];
                                
//                                 return (
//                                   <div onClick={(e) => e.preventDefault()}>
//                                     <WishlistButton 
//                                       productVariantId={availableVariant.id}
//                                       className="fixed-wishlist-btn"
//                                     />
//                                   </div>
//                                 );
//                               })()}
//                             </div>

//                             {/* Product Info Section */}
//                             <div className="card-body">
//                               {/* Brand Name */}
//                               <p className="product-brand-text mb-1">
//                                 {product?.brand?.nameEn}
//                               </p>

//                               {/* Product Title */}
//                               <h5 className="product-title">
//                                 {lang === "EN"
//                                   ? product?.nameEn
//                                   : product?.nameAr}
//                               </h5>

//                               {/* Product Description */}
//                               <p className="product-description">
//                                 {lang === "EN"
//                                   ? product?.descriptionEn
//                                   : product?.descriptionAr}
//                               </p>

//                               {/* Available Colors */}
//                               {availableColors.length > 0 && (
//                                 <div className="product-colors-display">
//                                   {availableColors
//                                     .slice(0, 5)
//                                     .map((color, i) => (
//                                       <div
//                                         key={i}
//                                         className="color-dot"
//                                         style={{
//                                           backgroundColor: color,
//                                         }}
//                                       />
//                                     ))}
//                                   {availableColors.length > 5 && (
//                                     <span className="color-count">
//                                       +{availableColors.length - 5}
//                                     </span>
//                                   )}
//                                 </div>
//                               )}

//                               {/* Available Sizes */}
//                               {availableSizes.length > 0 && (
//                                 <div className="product-sizes-display">
//                                   {availableSizes.slice(0, 5).map((size, i) => (
//                                     <span key={i} className="size-badge">
//                                       {size}
//                                     </span>
//                                   ))}
//                                   {availableSizes.length > 5 && (
//                                     <span className="size-count">
//                                       +{availableSizes.length - 5}
//                                     </span>
//                                   )}
//                                 </div>
//                               )}

//                               {/* Price Section */}
//                               <div className="price-section">
//                                 <span className="price-badge">
//                                   EGP {minPrice.toFixed(0)}
//                                 </span>
//                                 {minPrice !== maxPrice && (
//                                   <>
//                                     <span className="text-muted">-</span>
//                                     <span className="price-badge">
//                                       {maxPrice.toFixed(0)}
//                                     </span>
//                                   </>
//                                 )}
//                                 {hasDiscount && (
//                                   <span className="original-price">
//                                     EGP {maxPrice.toFixed(0)}
//                                   </span>
//                                 )}
//                               </div>

//                               {/* View Details Button */}
//                               <div className="d-flex gap-2">
//                                 <button className="btn flex-grow-1 view-details-btn text-light">
//                                   {lang === "EN"
//                                     ? "View Details"
//                                     : "تفاصيل المنتج"}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </Link>
//                       </div>
//                     );
//                   })}
//                 </div>

//                 {/* Infinite Scroll Trigger */}
//                 {hasMoreProducts && (
//                   <div 
//                     ref={observerTarget} 
//                     className="infinite-scroll-trigger"
//                   >
//                     {loadingMore && (
//                       <div className="loading-more-container">
//                         <Loader className="loader-spin" size={32} />
//                         <p className="loading-more-text">
//                           {lang === "EN" ? "Loading more..." : "جاري تحميل المزيد..."}
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* ✨ Mobile Fixed Bottom Bar */}
//       <div className="mobile-bottom-bar">
//         <button 
//           className="mobile-action-btn"
//           onClick={() => setShowSortModal(true)}
//         >
//           <ChevronDown size={20} />
//           <span>{lang === "EN" ? "Sort By" : "ترتيب"}</span>
//         </button>
//         <button 
//           className="mobile-action-btn"
//           onClick={() => setShowFilterModal(true)}
//         >
//           <Filter size={20} />
//           <span>{lang === "EN" ? "Filter" : "فلتر"}</span>
//           {activeFiltersCount > 0 && (
//             <span className="filter-badge">{activeFiltersCount}</span>
//           )}
//         </button>
//       </div>

//       {/* ✨ Filter Modal (Mobile) */}
//       {showFilterModal && (
//         <div className="mobile-modal-overlay" onClick={() => setShowFilterModal(false)}>
//           <div className="mobile-modal-content" onClick={(e) => e.stopPropagation()}>
//             {/* Modal Header */}
//             <div className="modal-header-custom">
//               <h3>{lang === "EN" ? "Filters" : "الفلاتر"}</h3>
//               <button onClick={() => setShowFilterModal(false)} className="modal-close-btn">
//                 <X size={24} />
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="modal-body-custom">
//               <FilterSections
//                 expandedSections={expandedSections}
//                 toggleSection={toggleSection}
//                 filters={filters}
//                 toggleStatusFilter={toggleStatusFilter}
//                 filterOptions={filterOptions}
//                 toggleFilter={toggleFilter}
//                 lang={lang}
//               />
//             </div>

//             {/* Modal Footer */}
//             <div className="modal-footer-custom">
//               <button onClick={clearAllFilters} className="btn-clear">
//                 {lang === "EN" ? "Clear All" : "مسح الكل"}
//               </button>
//               <button onClick={applyFilters} className="btn-apply">
//                 {lang === "EN" ? "Apply Filters" : "تطبيق الفلاتر"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ✨ Sort Modal (Mobile) */}
//       {showSortModal && (
//         <div className="mobile-modal-overlay" onClick={() => setShowSortModal(false)}>
//           <div className="mobile-modal-content sort-modal" onClick={(e) => e.stopPropagation()}>
//             {/* Modal Header */}
//             <div className="modal-header-custom">
//               <h3>{lang === "EN" ? "Sort By" : "ترتيب حسب"}</h3>
//               <button onClick={() => setShowSortModal(false)} className="modal-close-btn">
//                 <X size={24} />
//               </button>
//             </div>

//             {/* Modal Body */}
//             <div className="modal-body-custom">
//               {sortOptions.map(option => (
//                 <div 
//                   key={option.value}
//                   className={`sort-option ${filters.sortBy === option.value ? 'active' : ''}`}
//                   onClick={() => applySort(option.value)}
//                 >
//                   <span>{option.label}</span>
//                   {filters.sortBy === option.value && <Check size={20} />}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // ✨ Filter Sections Component (Reusable)
// const FilterSections = ({ 
//   expandedSections, 
//   toggleSection, 
//   filters, 
//   toggleStatusFilter, 
//   filterOptions, 
//   toggleFilter, 
//   lang 
// }) => {
//   return (
//     <>
//       {/* Status Filter */}
//       <div className="filter-section">
//         <button
//           onClick={() => toggleSection("status")}
//           className={`filter-section-header ${expandedSections.status ? "expanded" : ""}`}
//         >
//           <h6 className="filter-section-title">
//             {lang === "EN" ? "Status" : "حالة المنتج"}
//           </h6>
//           {expandedSections.status ? (
//             <ChevronUp size={18} />
//           ) : (
//             <ChevronDown size={18} />
//           )}
//         </button>
//         {expandedSections.status && (
//           <div className="filter-collapse">
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="status-new"
//                 checked={filters.isNew === true}
//                 onChange={() => toggleStatusFilter("isNew")}
//               />
//               <label
//                 className="form-check-label"
//                 htmlFor="status-new"
//               >
//                 {lang === "EN" ? "New Arrival" : "جديد"}
//               </label>
//             </div>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="status-trend"
//                 checked={filters.isTrend === true}
//                 onChange={() => toggleStatusFilter("isTrend")}
//               />
//               <label
//                 className="form-check-label"
//                 htmlFor="status-trend"
//               >
//                 {lang === "EN" ? "Trending" : "ترندات"}
//               </label>
//             </div>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="status-topseller"
//                 checked={filters.isTopSeller === true}
//                 onChange={() => toggleStatusFilter("isTopSeller")}
//               />
//               <label
//                 className="form-check-label"
//                 htmlFor="status-topseller"
//               >
//                 {lang === "EN" ? "Top Seller" : "أكثر مبيعا"}
//               </label>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Category Filter */}
//       {filterOptions.categories.length > 0 && (
//         <div className="filter-section">
//           <button
//             onClick={() => toggleSection("category")}
//             className={`filter-section-header ${expandedSections.category ? "expanded" : ""}`}
//           >
//             <h6 className="filter-section-title">
//               {lang === "EN" ? "Category" : "قسم"}
//             </h6>
//             {expandedSections.category ? (
//               <ChevronUp size={18} />
//             ) : (
//               <ChevronDown size={18} />
//             )}
//           </button>
//           {expandedSections.category && (
//             <div className="filter-collapse">
//               {filterOptions.categories.map((category) => (
//                 <div key={category.id} className="form-check">
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     id={`category-${category.id}`}
//                     checked={filters.categoryIds.includes(
//                       category.id,
//                     )}
//                     onChange={() =>
//                       toggleFilter("categoryIds", category.id)
//                     }
//                   />
//                   <label
//                     className="form-check-label"
//                     htmlFor={`category-${category.id}`}
//                   >
//                     {category.name}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       {/* Sub Category Filter */}
//       {filterOptions.subCategories.length > 0 && (
//         <div className="filter-section">
//           <button
//             onClick={() => toggleSection("subCategory")}
//             className={`filter-section-header ${expandedSections.subCategory ? "expanded" : ""}`}
//           >
//             <h6 className="filter-section-title">
//               {lang === "EN" ? "Sub Category" : "فئة"}
//             </h6>
//             {expandedSections.subCategory ? (
//               <ChevronUp size={18} />
//             ) : (
//               <ChevronDown size={18} />
//             )}
//           </button>
//           {expandedSections.subCategory && (
//             <div className="filter-collapse">
//               {filterOptions.subCategories.map((subCategory) => (
//                 <div key={subCategory.id} className="form-check">
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     id={`subCategory-${subCategory.id}`}
//                     checked={filters.subCategoryIds.includes(
//                       subCategory.id,
//                     )}
//                     onChange={() =>
//                       toggleFilter("subCategoryIds", subCategory.id)
//                     }
//                   />
//                   <label
//                     className="form-check-label"
//                     htmlFor={`subCategory-${subCategory.id}`}
//                   >
//                     {subCategory.name}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       {/* Brand Filter */}
//       {filterOptions.brands.length > 0 && (
//         <div className="filter-section">
//           <button
//             onClick={() => toggleSection("brand")}
//             className={`filter-section-header ${expandedSections.brand ? "expanded" : ""}`}
//           >
//             <h6 className="filter-section-title">
//               {lang === "EN" ? "Brand" : "ماركة"}
//             </h6>
//             {expandedSections.brand ? (
//               <ChevronUp size={18} />
//             ) : (
//               <ChevronDown size={18} />
//             )}
//           </button>
//           {expandedSections.brand && (
//             <div className="filter-collapse">
//               {filterOptions.brands.map((brand) => (
//                 <div key={brand.id} className="form-check">
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     id={`brand-${brand.id}`}
//                     checked={filters.brandIds.includes(brand.id)}
//                     onChange={() =>
//                       toggleFilter("brandIds", brand.id)
//                     }
//                   />
//                   <label
//                     className="form-check-label"
//                     htmlFor={`brand-${brand.id}`}
//                   >
//                     {brand.nameEn}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       {/* Color Filter */}
//       {filterOptions.colors.length > 0 && (
//         <div className="filter-section">
//           <button
//             onClick={() => toggleSection("color")}
//             className={`filter-section-header ${expandedSections.color ? "expanded" : ""}`}
//           >
//             <h6 className="filter-section-title">
//               {lang === "EN" ? "Color" : "لون"}
//             </h6>
//             {expandedSections.color ? (
//               <ChevronUp size={18} />
//             ) : (
//               <ChevronDown size={18} />
//             )}
//           </button>
//           {expandedSections.color && (
//             <div className="filter-collapse">
//               <div className="color-options-grid">
//                 {filterOptions.colors.map((color) => (
//                   <div
//                     key={color.id}
//                     className={`color-option ${filters.colorIds.includes(color.id) ? "selected" : ""}`}
//                     style={{ backgroundColor: color.hexCode }}
//                     onClick={() =>
//                       toggleFilter("colorIds", color.id)
//                     }
//                     title={color.nameEn || "Color"}
//                   />
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Size Filter */}
//       {filterOptions.sizes.length > 0 && (
//         <div className="filter-section">
//           <button
//             onClick={() => toggleSection("size")}
//             className={`filter-section-header ${expandedSections.size ? "expanded" : ""}`}
//           >
//             <h6 className="filter-section-title">
//               {lang === "EN" ? "Size" : "مقاس"}
//             </h6>
//             {expandedSections.size ? (
//               <ChevronUp size={18} />
//             ) : (
//               <ChevronDown size={18} />
//             )}
//           </button>
//           {expandedSections.size && (
//             <div className="filter-collapse">
//               <div className="size-options-grid">
//                 {filterOptions.sizes.map((size) => (
//                   <div
//                     key={size.id}
//                     className={`size-option ${filters.sizeIds.includes(size.id) ? "selected" : ""}`}
//                     onClick={() => toggleFilter("sizeIds", size.id)}
//                   >
//                     {size.nameEn}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default ProductsCollectionList;




import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Filter, X, ChevronDown, ChevronUp, Loader, Check } from "lucide-react";
import { FaShoppingBag } from "react-icons/fa";
import { BsCheckCircleFill, BsTrash3Fill } from "react-icons/bs";
import "./ProductsCollectionList.scss";
import ProductsApiService from "../../services/ProductsApiService";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";
import { getLanguage } from "../../utils/Helper";
import { toast } from "react-toastify";
import WishlistButton from "../../components/general/wishlistButton/WishlistButton";

const ProductsCollectionList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [, setError] = useState(null);
  const [colorsAndSizes, setColorsAndSizes] = useState(null);
  const lang = getLanguage();

  const { collectionName, categoryName } = useParams();
  const location = useLocation();
  const authContext = useAuth();
  
  const { addToCart, removeFromCart, isInCart } = useCart();

  const [cartStates, setCartStates] = useState({});
  const [hoveredProducts, setHoveredProducts] = useState({});
  const addToCartTimeoutRefs = useRef({});
  
  const observerTarget = useRef(null);
  const isFirstLoad = useRef(true);
  const isFetchingRef = useRef(false);

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showSortModal, setShowSortModal] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const subCategoriesParams = queryParams.get("sub_cat")
    ? queryParams.get("sub_cat").split(",")
    : [];
  const brandsParams = queryParams.get("brand")
    ? queryParams.get("brand").split(",")
    : [];

  const [currentCollection, setCurrentCollection] = useState(null);
  const [, setActiveCategory] = useState(null);

  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  });

  const [filters, setFilters] = useState({
    collectionId: currentCollection?.id,
    categoryIds: [],
    subCategoryIds: [],
    brandIds: [],
    colorIds: [],
    sizeIds: [],
    minPrice: null,
    maxPrice: null,
    search: "",
    isNew: null,
    isTrend: null,
    isTopSeller: null,
    sortBy: "newest",
  });

  const [showFilters, ] = useState(true);
  const [expandedSections, setExpandedSections] = useState({
    category: true,
    subCategory: false,
    brand: false,
    color: false,
    size: false,
    status: true,
  });

  const filterOptions = useMemo(() => {
    if (!currentCollection || !colorsAndSizes)
      return {
        categories: [],
        subCategories: [],
        brands: [],
        colors: [],
        sizes: [],
      };

    const categories = new Map();
    const subCategories = new Map();
    const brands = new Map();
    const colors = new Map();
    const sizes = new Map();

    currentCollection?.categories.forEach((cat) => {
      if (cat) categories.set(cat?.id, { ...cat, nameEn: cat.name_url });
      cat?.sub_categories.forEach((sub) => {
        if (sub)
          subCategories.set(sub?.id, {
            ...sub,
            nameEn: sub.name_url,
            categoryId: cat.id,
          });
      });
    });

    currentCollection?.top_brands.forEach((brand) => {
      if (brand) {
        brands.set(brand?.id, { ...brand, nameEn: brand.name_url });
      }
    });

    colorsAndSizes?.colors.forEach((color) => {
      if (color) colors.set(color.id, color);
    });

    colorsAndSizes?.sizes.forEach((size) => {
      if (size) sizes.set(size.id, size);
    });

    let filteredSubCategories = Array.from(subCategories.values());
    if (filters.categoryIds.length > 0) {
      filteredSubCategories = filteredSubCategories.filter((sub) =>
        filters.categoryIds.includes(sub.categoryId),
      );
    }

    return {
      categories: Array.from(categories.values()),
      subCategories: filteredSubCategories,
      brands: Array.from(brands.values()),
      colors: Array.from(colors.values()),
      sizes: Array.from(sizes.values()),
    };
  }, [currentCollection, colorsAndSizes, filters.categoryIds]);

  const fetchProducts = async (isLoadMore = false) => {
    if (!currentCollection || !colorsAndSizes) return;

    try {
      if (isLoadMore) {
        setLoadingMore(true);
      } else {
        setLoading(true);
      }
      setError(null);
      const queryParams = new URLSearchParams();
      queryParams.append("page", pagination.currentPage);
      queryParams.append("limit", pagination.pageSize);

      queryParams.append("collectionId", currentCollection?.id);
      if (filters.categoryIds.length)
        filters.categoryIds.forEach((id) =>
          queryParams.append("categoryIds", id),
        );
      if (filters.subCategoryIds.length)
        filters.subCategoryIds.forEach((id) =>
          queryParams.append("subCategoryIds", id),
        );
      if (filters.brandIds.length)
        filters.brandIds.forEach((id) => queryParams.append("brandIds", id));
      if (filters.colorIds.length)
        filters.colorIds.forEach((id) => queryParams.append("colorIds", id));
      if (filters.sizeIds.length)
        filters.sizeIds.forEach((id) => queryParams.append("sizeIds", id));
      if (filters.minPrice) queryParams.append("minPrice", filters.minPrice);
      if (filters.maxPrice) queryParams.append("maxPrice", filters.maxPrice);
      if (filters.search) queryParams.append("search", filters.search);
      if (filters.isNew !== null) queryParams.append("isNew", filters.isNew);
      if (filters.isTrend !== null)
        queryParams.append("isTrend", filters.isTrend);
      if (filters.isTopSeller !== null)
        queryParams.append("isTopSeller", filters.isTopSeller);
      queryParams.append("sortBy", filters.sortBy);

      const response =
        await ProductsApiService.getProductsListWithFilters(queryParams);

      if (isLoadMore) {
        setProducts((prev) => {
          const existingIds = new Set(prev.map(p => p.id));
          const newProducts = (response.products || []).filter(
            product => !existingIds.has(product.id)
          );
          return [...prev, ...newProducts];
        });
      } else {
        setProducts(response.products || []);
      }

      setPagination({
        currentPage: response.currentPage,
        pageSize: response.pageSize,
        totalCount: response.totalCount,
        totalPages: response.totalPages,
      });
    } catch (err) {
      setError(err.message);
      setPagination({
        currentPage: 0,
        pageSize: 10,
        totalCount: 0,
        totalPages: 0,
      });
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleLoadMore = useCallback(() => {
    if (loadingMore || loading || isFetchingRef.current) return;
    if (pagination.currentPage >= pagination.totalPages - 1) return;
    
    isFetchingRef.current = true;
    setPagination((prev) => ({ ...prev, currentPage: prev.currentPage + 1 }));
  }, [loadingMore, loading, pagination.currentPage, pagination.totalPages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        
        if (
          target.isIntersecting && 
          !loadingMore && 
          !loading && 
          !isFetchingRef.current &&
          pagination.currentPage < pagination.totalPages - 1
        ) {
          handleLoadMore();
        }
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0.1,
      }
    );

    const currentTarget = observerTarget.current;
    if (currentTarget) {
      observer.observe(currentTarget);
    }

    return () => {
      if (currentTarget) {
        observer.unobserve(currentTarget);
      }
    };
  }, [handleLoadMore, loadingMore, loading, pagination.currentPage, pagination.totalPages]);

  function loadCollectionsData() {
    if (!authContext?.systemCollections?.length) return;

    const collection = authContext.systemCollections.find(
      (col) =>
        col.name_url.toLowerCase().trim() ===
        collectionName.split("-").join(" ").toLowerCase().trim(),
    );
    if (!collection) return;

    setCurrentCollection(collection);

    if (categoryName) {
      const category = collection.categories.find(
        (cat) =>
          cat.name_url.toLowerCase().trim() ===
          categoryName.split("-").join(" ").toLowerCase().trim(),
      );
      setActiveCategory(category);

      const selectedSubIds =
        category?.sub_categories
          .filter((subCat) =>
            subCategoriesParams.some(
              (name) =>
                subCat.name_url.toLowerCase().trim() ===
                name.split("-").join(" ").toLowerCase().trim(),
            ),
          )
          .map((sub) => sub.id) || [];

      setFilters((prev) => ({
        ...prev,
        collectionId: collection.id,
        categoryIds: category ? [category.id] : [],
        subCategoryIds: selectedSubIds,
        brandIds:
          collection?.top_brands
            ?.filter((brand) =>
              brandsParams.some(
                (name) =>
                  brand.name_url.toLowerCase().trim() ===
                  name.split("-").join(" ").toLowerCase().trim(),
              ),
            )
            .map((br) => br.id) || [],
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        categoryIds: [],
        subCategoryIds: [],
        collectionId: collection.id,
        brandIds:
          collection?.top_brands
            ?.filter((brand) =>
              brandsParams.some(
                (name) =>
                  brand.name_url.toLowerCase().trim() ===
                  name.split("-").join(" ").toLowerCase().trim(),
              ),
            )
            .map((br) => br.id) || [],
      }));
    }
  }

  async function fetchColorsAndSizes() {
    try {
      if (colorsAndSizes?.colors && colorsAndSizes?.sizes) return;
      const response = await ProductsApiService.getColorsAndSizesByFilters({
        collectionId: currentCollection?.id,
        categoryIds: filters.categoryIds?.join(","),
        subCategoryIds: filters.subCategoryIds?.join(","),
        brandIds: filters.brandIds?.join(","),
      });
      setColorsAndSizes(response);
    } catch (err) {
      console.error("Error fetching colors and sizes:", err);
    }
  }

  const isProductOutOfStock = useCallback((product) => {
    if (!product.variants || product.variants.length === 0) {
      return true;
    }

    let outOfStock = true;
    product.variants.forEach((v) => {
      if ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0)) {
        outOfStock = false;
        return;
      }
    });

    return outOfStock;
  }, []);

  const getVariantInfo = useCallback((product) => {
    if (!product.variants || product.variants.length === 0) return { variant: null, isWithoutBox: false };

    const availableVariant = product.variants.find(
      (v) => (v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0),
    ) || product.variants[0];

    const isWithoutBox = (availableVariant.quantity - availableVariant.reservedQuantity) <= 0 && 
                         (availableVariant.withoutBoxQuantity - availableVariant.withoutBoxReservedQuantity) > 0;

    return { variant: availableVariant, isWithoutBox };
  }, []);

  const handleCartAction = useCallback(
    async (e, product) => {
      e.preventDefault();
      e.stopPropagation();

      if (isProductOutOfStock(product)) {
        toast.warning(
          lang === "EN" ? "Product is out of stock" : "المنتج غير متوفر حالياً",
        );
        return;
      }

      const productId = product.id;
      const { variant: apiVariant, isWithoutBox } = getVariantInfo(product);

      if (!apiVariant) {
        toast.error(
          lang === "EN"
            ? "This product has no available variants"
            : "هذا المنتج ليس له مقاسات متاحة",
        );
        return;
      }

      // Check if product is in cart
      const productInCart = isInCart(apiVariant.id, isWithoutBox);

      if (cartStates[productId]?.isProcessing) return;

      if (addToCartTimeoutRefs.current[productId]) {
        clearTimeout(addToCartTimeoutRefs.current[productId]);
      }

      setCartStates((prev) => ({
        ...prev,
        [productId]: { isProcessing: true, showSuccess: false },
      }));

      try {
        if (productInCart) {
          await removeFromCart(product.id, apiVariant.id, isWithoutBox);
          
          // toast.success(
          //   lang === "EN" 
          //     ? "Removed from cart!" 
          //     : "تم الحذف من السلة!",
          //   {
          //     position: lang === "AR" ? "top-right" : "top-left",
          //     autoClose: 2000,
          //   }
          // );
          
          setCartStates((prev) => ({
            ...prev,
            [productId]: { isProcessing: false, showSuccess: false },
          }));
        } else {
          const variant = {
            id: apiVariant.id,
            productId: apiVariant.productId,
            color: apiVariant.color,
            size: apiVariant.size,
            price:
              typeof apiVariant.price === "object"
                ? apiVariant.price.parsedValue
                : apiVariant.price,
            discountPrice:
              apiVariant.discountPrice &&
              typeof apiVariant.discountPrice === "object"
                ? apiVariant.discountPrice.parsedValue
                : apiVariant.discountPrice,
            quantity: apiVariant.quantity,
            reservedQuantity: apiVariant.reservedQuantity,
            withoutBoxQuantity: apiVariant.withoutBoxQuantity,
            withoutBoxReservedQuantity: apiVariant.withoutBoxReservedQuantity,
            stockStatus: apiVariant.stockStatus || "In Stock",
          };

          const cartProduct = {
            id: product.id,
            nameEn: product.nameEn,
            nameAr: product.nameAr,
            descriptionEn: product.descriptionEn,
            descriptionAr: product.descriptionAr,
            images: [{ image_url: product.primaryImageUrl }],
            brand: {
              nameEn: product.brand?.nameEn,
              nameAr: product.brand?.nameAr,
            },
            collection: { nameEn: product.collection?.nameEn },
            category: { nameEn: product.category?.nameEn },
            subCategory: { nameEn: product.subCategory?.nameEn },
          };

          await addToCart(cartProduct, variant, 1, isWithoutBox, false);

          setCartStates((prev) => ({
            ...prev,
            [productId]: { isProcessing: false, showSuccess: true },
          }));

          addToCartTimeoutRefs.current[productId] = setTimeout(() => {
            setCartStates((prev) => ({
              ...prev,
              [productId]: { isProcessing: false, showSuccess: false },
            }));
          }, 2000);
        }
      } catch (error) {
        console.error("Error with cart action:", error);
        toast.error(
          lang === "EN"
            ? "Something went wrong"
            : "حدث خطأ",
        );
        setCartStates((prev) => ({
          ...prev,
          [productId]: { isProcessing: false, showSuccess: false },
        }));
      }
    },
    [addToCart, removeFromCart, isInCart, cartStates, lang, isProductOutOfStock, getVariantInfo],
  );

  useEffect(() => {
    if (
      currentCollection &&
      colorsAndSizes &&
      pagination?.currentPage !== null
    ) {
      const isLoadMore = pagination.currentPage > 0;
      fetchProducts(isLoadMore).finally(() => {
        isFetchingRef.current = false;
      });
      
      if (isFirstLoad.current && !isLoadMore) {
        isFirstLoad.current = false;
      }
    }
  }, [pagination.currentPage, currentCollection, colorsAndSizes]);

  useEffect(() => {
    setColorsAndSizes(null);
    setProducts([]);
    setPagination({
      currentPage: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
    });
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    loadCollectionsData();
  }, [authContext, collectionName, categoryName, location.search]);

  useEffect(() => {
    if (currentCollection) {
      fetchColorsAndSizes();
    }
  }, [currentCollection, collectionName, filters]);

  useEffect(() => {
    if (pagination.currentPage === 0) {
        fetchProducts(false);
    } else {
      setPagination((prev) => ({ ...prev, currentPage: 0 }));
      setProducts([]);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [filters]);

  const toggleFilter = (filterType, id) => {
    setFilters((prev) => {
      const newFilters = {
        ...prev,
        [filterType]: prev[filterType].includes(id)
          ? prev[filterType].filter((item) => item !== id)
          : [...prev[filterType], id],
      };

      if (filterType === "categoryIds" && prev[filterType].includes(id)) {
        const subCatsToRemove = filterOptions.subCategories
          .filter((sub) => sub.categoryId === id)
          .map((sub) => sub.id);

        newFilters.subCategoryIds = prev.subCategoryIds.filter(
          (subId) => !subCatsToRemove.includes(subId),
        );
      }

      return newFilters;
    });
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const toggleStatusFilter = (statusType) => {
    setFilters((prev) => ({
      ...prev,
      [statusType]: prev[statusType] ? null : true,
    }));
  };

  const clearAllFilters = () => {
    setFilters({
      categoryIds: [],
      subCategoryIds: [],
      brandIds: [],
      colorIds: [],
      sizeIds: [],
      minPrice: null,
      maxPrice: null,
      search: "",
      isNew: null,
      isTrend: null,
      isTopSeller: null,
      sortBy: "newest",
    });
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const activeFiltersCount =
    filters.categoryIds.length +
    filters.subCategoryIds.length +
    filters.brandIds.length +
    filters.colorIds.length +
    filters.sizeIds.length +
    (filters.isNew ? 1 : 0) +
    (filters.isTrend ? 1 : 0) +
    (filters.isTopSeller ? 1 : 0);

  const openProductProfile = (pro) => {
    const collectionName = pro.collection.nameEn
      .toString()
      .toLowerCase()
      .trim()
      .split(" ")
      .join("-");
    const catName = pro.category.nameEn
      .toString()
      .toLowerCase()
      .trim()
      .split(" ")
      .join("-");
    const subCatName = pro.subCategory.nameEn
      .toString()
      .toLowerCase()
      .trim()
      .split(" ")
      .join("-");
    return `/collection/${collectionName}/${catName}/${subCatName}/${pro.id}`;
  };

  const hasMoreProducts = pagination.currentPage < pagination.totalPages - 1;

  const sortOptions = [
    { value: "newest", label: lang === "EN" ? "Newest First" : "الأحدث أولاً" },
    { value: "oldest", label: lang === "EN" ? "Oldest First" : "الأقدم أولاً" },
    { value: "price-low", label: lang === "EN" ? "Price: Low to High" : "السعر: من الأقل إلى الأعلى" },
    { value: "price-high", label: lang === "EN" ? "Price: High to Low" : "السعر: من الأعلى إلى الأقل" },
  ];

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const applySort = (sortValue) => {
    setFilters((prev) => ({ ...prev, sortBy: sortValue }));
    setShowSortModal(false);
  };

  return (
    <div className="min-vh-100 pb-4 products-collection-page" style={{ paddingTop: "190px" }}>
      <div className="container-fluid py-3 px-lg-5">
        {/* Collection Hero Image */}
        {/* <div className="col-12 mb-4">
          <img
            src={currentCollection?.image_url}
            alt=""
            className="collection-image-section"
          />
        </div> */}

        <div className="row g-4">
          {/* Desktop Filters Sidebar */}
          {showFilters && (
            <div className="col-lg-3 desktop-filters">
              <div className="card shadow-sm filters-sidebar">
                <div className="card-body">
                  {/* Filter Header */}
                  <div className="filter-header">
                    <div className="filter-title">
                      <Filter size={20} />
                      <span>{lang === "EN" ? "Filters" : "الفلاتر"}</span>
                      {activeFiltersCount > 0 && (
                        <span className="filter-count">
                          {activeFiltersCount}
                        </span>
                      )}
                    </div>
                    {activeFiltersCount > 0 && (
                      <button
                        onClick={clearAllFilters}
                        className="clear-filters-btn"
                      >
                        {lang === "EN" ? "Clear all" : "مسح الكل"}
                      </button>
                    )}
                  </div>

                  {/* Filter Sections */}
                  <FilterSections
                    expandedSections={expandedSections}
                    toggleSection={toggleSection}
                    filters={filters}
                    toggleStatusFilter={toggleStatusFilter}
                    filterOptions={filterOptions}
                    toggleFilter={toggleFilter}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Products Grid */}
          <div className={showFilters ? "col-lg-9" : "col-12"}>
            {/* Desktop Top Controls */}
            <div className="top-controls desktop-only">
              <div className="results-count">
                <span>{pagination.totalCount}</span>{" "}
                {lang === "EN" ? "Products" : "منتج"}
              </div>
              <select
                className="sort-select"
                value={filters.sortBy}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, sortBy: e.target.value }))
                }
              >
                {sortOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            {/* Loading State */}
            {loading ? (
              <div className="loading-container">
                <Loader className="loader-spin" size={48} />
              </div>
            ) : products?.length === 0 ? (
              // Empty State
              <div className="empty-state">
                <X size={64} />
                <h3>
                  {lang === "EN" ? "No products found" : "لا يتوفر منتجات"}
                </h3>
                <p>
                  {lang === "EN"
                    ? "Try adjusting your filters"
                    : "يمكنك البحث عن منتجات أخري"}
                </p>
                <button onClick={clearAllFilters} className="btn">
                  {lang === "EN" ? "Clear all filters" : "أمسح الفلتر"}
                </button>
              </div>
            ) : (
              <>
                {/* Products Grid */}
                <div className="row g-4 products-grid-container">
                  {products?.map((product) => {
                    const minPrice = product?.variants
                      ? Math.min(
                          ...product?.variants?.map(
                            (v) => v.discountPrice || v.price,
                          ),
                        )
                      : 0;
                    const maxPrice = product?.variants
                      ? Math.max(...product?.variants?.map((v) => v.price))
                      : 0;
                    const hasDiscount = product?.variants
                      ? product?.variants?.some((v) => v.discountPrice)
                      : 0;
                    const availableColors = product?.variants
                      ? [
                          ...new Set(
                            product?.variants
                              ?.map((v) => v.color?.hexCode)
                              .filter(Boolean),
                          ),
                        ]
                      : [];
                    const availableSizes = product?.variants
                      ? [
                          ...new Set(
                            product?.variants
                              ?.map((v) => v.size?.nameEn)
                              .filter(Boolean),
                          ),
                        ]
                      : [];

                    const productCartState = cartStates[product.id] || {
                      isProcessing: false,
                      showSuccess: false,
                    };

                    // ✅ Check if product is in cart
                    const { variant: availableVariant, isWithoutBox } = getVariantInfo(product);
                    const productInCart = availableVariant ? isInCart(availableVariant.id, isWithoutBox) : false;
                    const isHovered = hoveredProducts[product.id] || false;

                    return (
                      <div key={product?.id} className="col-6 col-md-4 col-xl-3">
                        <Link
                          to={openProductProfile(product)}
                          style={{ textDecoration: "none" }}
                        >
                          <div 
                            className="card product-card h-100 shadow-sm border-0"
                            onMouseEnter={() => setHoveredProducts(prev => ({ ...prev, [product.id]: true }))}
                            onMouseLeave={() => setHoveredProducts(prev => ({ ...prev, [product.id]: false }))}
                          >
                            {/* Product Image Section */}
                            <div className="product-image-wrapper">
                              <img
                                src={
                                  product?.primaryImageUrl ||
                                  "https://via.placeholder.com/400"
                                }
                                alt={product?.nameEn}
                                className="product-image"
                              />

                              {/* Out of Stock Overlay */}
                              {isProductOutOfStock(product) && (
                                <div className="out-of-stock-overlay">
                                  <div className="out-of-stock-badge">
                                    {lang === "EN"
                                      ? "OUT OF STOCK"
                                      : "غير متوفر"}
                                  </div>
                                </div>
                              )}

                              {/* Brand Badge */}
                              {product?.brand?.imageUrl && (
                                <div className="brand-badge d-none d-md-block">
                                  <img
                                    src={product?.brand?.imageUrl}
                                    alt={product?.brand?.nameEn}
                                    className="brand-logo"
                                  />
                                </div>
                              )}

                              {/* Status Badges */}
                              <div className="badge-overlay">
                                {product?.isNew && (
                                  <span className="badge bg-success badge-tag">
                                    {lang === "EN" ? "NEW" : "جديد"}
                                  </span>
                                )}
                                {product?.isTrend && (
                                  <span
                                    className="badge badge-tag"
                                    style={{
                                      backgroundColor: "#6f42c1",
                                      color: "white",
                                    }}
                                  >
                                    {lang === "EN" ? "TRENDING" : "ترند"}
                                  </span>
                                )}
                                {product?.isTopSeller && (
                                  <span className="badge bg-warning text-dark badge-tag">
                                    {lang === "EN"
                                      ? "TOP SELLER"
                                      : "أكثر مبيعا"}
                                  </span>
                                )}
                              </div>

                              {/* Sale Badge */}
                              {hasDiscount && (
                                <span className="badge bg-danger sale-badge badge-tag">
                                  {lang === "EN" ? "SALE" : "تخفيض"}
                                </span>
                              )}

                              {/* ✅ IMPROVED: Cart Action Button */}
                              <button
                                className={`cart-action-button ${
                                  isProductOutOfStock(product) ? 'out-of-stock' : ''
                                } ${productCartState.isProcessing ? 'loading' : ''} ${
                                  productCartState.showSuccess ? 'success' : ''
                                } ${productInCart && !isHovered ? 'in-cart' : ''} ${
                                  productInCart && isHovered ? 'remove-mode' : ''
                                }`}
                                onClick={(e) => handleCartAction(e, product)}
                                disabled={
                                  productCartState.isProcessing ||
                                  isProductOutOfStock(product)
                                }
                                title={
                                  isProductOutOfStock(product) 
                                    ? (lang === "EN" ? "Out of stock" : "غير متوفر")
                                    : productInCart && isHovered
                                    ? (lang === "EN" ? "Remove from cart" : "إزالة من السلة")
                                    : productInCart
                                    ? (lang === "EN" ? "In cart" : "في السلة")
                                    : (lang === "EN" ? "Add to cart" : "أضف للسلة")
                                }
                              >
                                {/* Icon Container */}
                                <div className="button-icon">
                                  {productCartState.showSuccess ? (
                                    <BsCheckCircleFill size={20} className="icon-check" />
                                  ) : productInCart && isHovered ? (
                                    <BsTrash3Fill size={18} className="icon-trash" />
                                  ) : (
                                    <FaShoppingBag size={18} className="icon-bag" />
                                  )}
                                </div>

                                {/* Check Badge */}
                                {productInCart && !isHovered && !productCartState.showSuccess && (
                                  <div className="in-cart-badge">
                                    <BsCheckCircleFill size={14} />
                                  </div>
                                )}

                                {/* Loading Spinner */}
                                {productCartState.isProcessing && (
                                  <div className="loading-spinner" />
                                )}
                              </button>

                              {/* Wishlist Button */}
                              {(() => {
                                const availableVariant = product.variants.find(
                                  v => (v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0)
                                ) || product.variants[0];
                                
                                return (
                                  <div onClick={(e) => e.preventDefault()}>
                                    <WishlistButton 
                                      productVariantId={availableVariant.id}
                                      className="fixed-wishlist-btn"
                                    />
                                  </div>
                                );
                              })()}
                            </div>

                            {/* Product Info Section */}
                            <div className="card-body">
                              {/* Brand Name */}
                              <p className="product-brand-text mb-1">
                                {product?.brand?.nameEn}
                              </p>

                              {/* Product Title */}
                              <h5 className="product-title">
                                {lang === "EN"
                                  ? product?.nameEn
                                  : product?.nameAr}
                              </h5>

                              {/* Product Description */}
                              <p className="product-description">
                                {lang === "EN"
                                  ? product?.descriptionEn
                                  : product?.descriptionAr}
                              </p>

                              {/* Available Colors */}
                              {availableColors.length > 0 && (
                                <div className="product-colors-display">
                                  {availableColors
                                    .slice(0, 5)
                                    .map((color, i) => (
                                      <div
                                        key={i}
                                        className="color-dot"
                                        style={{
                                          backgroundColor: color,
                                        }}
                                      />
                                    ))}
                                  {availableColors.length > 5 && (
                                    <span className="color-count">
                                      +{availableColors.length - 5}
                                    </span>
                                  )}
                                </div>
                              )}

                              {/* Available Sizes */}
                              {availableSizes.length > 0 && (
                                <div className="product-sizes-display">
                                  {availableSizes.slice(0, 5).map((size, i) => (
                                    <span key={i} className="size-badge">
                                      {size}
                                    </span>
                                  ))}
                                  {availableSizes.length > 5 && (
                                    <span className="size-count">
                                      +{availableSizes.length - 5}
                                    </span>
                                  )}
                                </div>
                              )}

                              {/* Price Section */}
                              <div className="price-section">
                                <span className="price-badge">
                                  EGP {minPrice.toFixed(0)}
                                </span>
                                {/* {minPrice !== maxPrice && (
                                  <>
                                    <span className="text-muted">-</span>
                                    <span className="price-badge">
                                      {maxPrice.toFixed(0)}
                                    </span>
                                  </>
                                )} */}
                                {hasDiscount && (
                                  <span className="original-price">
                                    EGP {maxPrice.toFixed(0)}
                                  </span>
                                )}
                              </div>

                              {/* View Details Button */}
                              <div className="d-flex gap-2">
                                <button className="btn flex-grow-1 view-details-btn text-light">
                                  {lang === "EN"
                                    ? "View Details"
                                    : "تفاصيل المنتج"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>

                {/* Infinite Scroll Trigger */}
                {hasMoreProducts && (
                  <div 
                    ref={observerTarget} 
                    className="infinite-scroll-trigger"
                  >
                    {loadingMore && (
                      <div className="loading-more-container">
                        <Loader className="loader-spin" size={32} />
                        <p className="loading-more-text">
                          {lang === "EN" ? "Loading more..." : "جاري تحميل المزيد..."}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Fixed Bottom Bar */}
      <div className="mobile-bottom-bar">
        <button 
          className="mobile-action-btn"
          onClick={() => setShowSortModal(true)}
        >
          <ChevronDown size={20} />
          <span>{lang === "EN" ? "Sort By" : "ترتيب"}</span>
        </button>
        <button 
          className="mobile-action-btn"
          onClick={() => setShowFilterModal(true)}
        >
          <Filter size={20} />
          <span>{lang === "EN" ? "Filter" : "فلتر"}</span>
          {activeFiltersCount > 0 && (
            <span className="filter-badge">{activeFiltersCount}</span>
          )}
        </button>
      </div>

      {/* Filter Modal (Mobile) */}
      {showFilterModal && (
        <div className="mobile-modal-overlay" onClick={() => setShowFilterModal(false)}>
          <div className="mobile-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <h3>{lang === "EN" ? "Filters" : "الفلاتر"}</h3>
              <button onClick={() => setShowFilterModal(false)} className="modal-close-btn">
                <X size={24} />
              </button>
            </div>

            <div className="modal-body-custom">
              <FilterSections
                expandedSections={expandedSections}
                toggleSection={toggleSection}
                filters={filters}
                toggleStatusFilter={toggleStatusFilter}
                filterOptions={filterOptions}
                toggleFilter={toggleFilter}
                lang={lang}
              />
            </div>

            <div className="modal-footer-custom">
              <button onClick={clearAllFilters} className="btn-clear">
                {lang === "EN" ? "Clear All" : "مسح الكل"}
              </button>
              <button onClick={applyFilters} className="btn-apply">
                {lang === "EN" ? "Apply Filters" : "تطبيق الفلاتر"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Sort Modal (Mobile) */}
      {showSortModal && (
        <div className="mobile-modal-overlay" onClick={() => setShowSortModal(false)}>
          <div className="mobile-modal-content sort-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <h3>{lang === "EN" ? "Sort By" : "ترتيب حسب"}</h3>
              <button onClick={() => setShowSortModal(false)} className="modal-close-btn">
                <X size={24} />
              </button>
            </div>

            <div className="modal-body-custom">
              {sortOptions.map(option => (
                <div 
                  key={option.value}
                  className={`sort-option ${filters.sortBy === option.value ? 'active' : ''}`}
                  onClick={() => applySort(option.value)}
                >
                  <span>{option.label}</span>
                  {filters.sortBy === option.value && <Check size={20} />}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Filter Sections Component (Reusable)
const FilterSections = ({ 
  expandedSections, 
  toggleSection, 
  filters, 
  toggleStatusFilter, 
  filterOptions, 
  toggleFilter, 
  lang 
}) => {
  return (
    <>
      {/* Status Filter */}
      <div className="filter-section">
        <button
          onClick={() => toggleSection("status")}
          className={`filter-section-header ${expandedSections.status ? "expanded" : ""}`}
        >
          <h6 className="filter-section-title">
            {lang === "EN" ? "Status" : "حالة المنتج"}
          </h6>
          {expandedSections.status ? (
            <ChevronUp size={18} />
          ) : (
            <ChevronDown size={18} />
          )}
        </button>
        {expandedSections.status && (
          <div className="filter-collapse">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="status-new"
                checked={filters.isNew === true}
                onChange={() => toggleStatusFilter("isNew")}
              />
              <label
                className="form-check-label"
                htmlFor="status-new"
              >
                {lang === "EN" ? "New Arrival" : "جديد"}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="status-trend"
                checked={filters.isTrend === true}
                onChange={() => toggleStatusFilter("isTrend")}
              />
              <label
                className="form-check-label"
                htmlFor="status-trend"
              >
                {lang === "EN" ? "Trending" : "ترندات"}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="status-topseller"
                checked={filters.isTopSeller === true}
                onChange={() => toggleStatusFilter("isTopSeller")}
              />
              <label
                className="form-check-label"
                htmlFor="status-topseller"
              >
                {lang === "EN" ? "Top Seller" : "أكثر مبيعا"}
              </label>
            </div>
          </div>
        )}
      </div>

      {/* Category Filter */}
      {filterOptions.categories.length > 0 && (
        <div className="filter-section">
          <button
            onClick={() => toggleSection("category")}
            className={`filter-section-header ${expandedSections.category ? "expanded" : ""}`}
          >
            <h6 className="filter-section-title">
              {lang === "EN" ? "Category" : "قسم"}
            </h6>
            {expandedSections.category ? (
              <ChevronUp size={18} />
            ) : (
              <ChevronDown size={18} />
            )}
          </button>
          {expandedSections.category && (
            <div className="filter-collapse">
              {filterOptions.categories.map((category) => (
                <div key={category.id} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`category-${category.id}`}
                    checked={filters.categoryIds.includes(
                      category.id,
                    )}
                    onChange={() =>
                      toggleFilter("categoryIds", category.id)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`category-${category.id}`}
                  >
                    {category.name}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Sub Category Filter */}
      {filterOptions.subCategories.length > 0 && (
        <div className="filter-section">
          <button
            onClick={() => toggleSection("subCategory")}
            className={`filter-section-header ${expandedSections.subCategory ? "expanded" : ""}`}
          >
            <h6 className="filter-section-title">
              {lang === "EN" ? "Sub Category" : "فئة"}
            </h6>
            {expandedSections.subCategory ? (
              <ChevronUp size={18} />
            ) : (
              <ChevronDown size={18} />
            )}
          </button>
          {expandedSections.subCategory && (
            <div className="filter-collapse">
              {filterOptions.subCategories.map((subCategory) => (
                <div key={subCategory.id} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`subCategory-${subCategory.id}`}
                    checked={filters.subCategoryIds.includes(
                      subCategory.id,
                    )}
                    onChange={() =>
                      toggleFilter("subCategoryIds", subCategory.id)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`subCategory-${subCategory.id}`}
                  >
                    {subCategory.name}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Brand Filter */}
      {filterOptions.brands.length > 0 && (
        <div className="filter-section">
          <button
            onClick={() => toggleSection("brand")}
            className={`filter-section-header ${expandedSections.brand ? "expanded" : ""}`}
          >
            <h6 className="filter-section-title">
              {lang === "EN" ? "Brand" : "ماركة"}
            </h6>
            {expandedSections.brand ? (
              <ChevronUp size={18} />
            ) : (
              <ChevronDown size={18} />
            )}
          </button>
          {expandedSections.brand && (
            <div className="filter-collapse">
              {filterOptions.brands.map((brand) => (
                <div key={brand.id} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`brand-${brand.id}`}
                    checked={filters.brandIds.includes(brand.id)}
                    onChange={() =>
                      toggleFilter("brandIds", brand.id)
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`brand-${brand.id}`}
                  >
                    {brand.nameEn}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Color Filter */}
      {filterOptions.colors.length > 0 && (
        <div className="filter-section">
          <button
            onClick={() => toggleSection("color")}
            className={`filter-section-header ${expandedSections.color ? "expanded" : ""}`}
          >
            <h6 className="filter-section-title">
              {lang === "EN" ? "Color" : "لون"}
            </h6>
            {expandedSections.color ? (
              <ChevronUp size={18} />
            ) : (
              <ChevronDown size={18} />
            )}
          </button>
          {expandedSections.color && (
            <div className="filter-collapse">
              <div className="color-options-grid">
                {filterOptions.colors.map((color) => (
                  <div
                    key={color.id}
                    className={`color-option ${filters.colorIds.includes(color.id) ? "selected" : ""}`}
                    style={{ backgroundColor: color.hexCode }}
                    onClick={() =>
                      toggleFilter("colorIds", color.id)
                    }
                    title={color.nameEn || "Color"}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Size Filter */}
      {filterOptions.sizes.length > 0 && (
        <div className="filter-section">
          <button
            onClick={() => toggleSection("size")}
            className={`filter-section-header ${expandedSections.size ? "expanded" : ""}`}
          >
            <h6 className="filter-section-title">
              {lang === "EN" ? "Size" : "مقاس"}
            </h6>
            {expandedSections.size ? (
              <ChevronUp size={18} />
            ) : (
              <ChevronDown size={18} />
            )}
          </button>
          {expandedSections.size && (
            <div className="filter-collapse">
              <div className="size-options-grid">
                {filterOptions.sizes.map((size) => (
                  <div
                    key={size.id}
                    className={`size-option ${filters.sizeIds.includes(size.id) ? "selected" : ""}`}
                    onClick={() => toggleFilter("sizeIds", size.id)}
                  >
                    {size.nameEn}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ProductsCollectionList;